package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Belize Flag (32x24dp)
 *
 * - ISO Alpha-2: BZ
 * - ISO Alpha-3: BLZ
 * - ISO Numeric: 084
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Belize: ImageVector by lazy {
    ImageVector.Builder(
        name = "Belize:BZ:BLZ:084:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF0168B4)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFE93C43)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(3f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE93C43)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 21f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(21f)
                horizontalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(16f, 18f)
                curveTo(12.686f, 18f, 10f, 15.314f, 10f, 12f)
                curveTo(10f, 8.686f, 12.686f, 6f, 16f, 6f)
                curveTo(19.314f, 6f, 22f, 8.686f, 22f, 12f)
                curveTo(22f, 15.314f, 19.314f, 18f, 16f, 18f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(16f, 20f)
                curveTo(11.582f, 20f, 8f, 16.418f, 8f, 12f)
                curveTo(8f, 7.582f, 11.582f, 4f, 16f, 4f)
                curveTo(20.418f, 4f, 24f, 7.582f, 24f, 12f)
                curveTo(24f, 16.418f, 20.418f, 20f, 16f, 20f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFF9C4C17)),
                strokeLineWidth = 0.5f,
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16f, 19f)
                curveTo(19.866f, 19f, 23f, 15.866f, 23f, 12f)
                curveTo(23f, 8.134f, 19.866f, 5f, 16f, 5f)
                curveTo(12.134f, 5f, 9f, 8.134f, 9f, 12f)
                curveTo(9f, 15.866f, 12.134f, 19f, 16f, 19f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5B8C39)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.573f, 4.083f)
                lineTo(15.418f, 4.418f)
                curveTo(15.674f, 4.557f, 15.771f, 4.872f, 15.771f, 5.062f)
                curveTo(15.771f, 5.251f, 15.671f, 5.395f, 15.418f, 5.527f)
                lineTo(15.573f, 5.873f)
                curveTo(15.679f, 5.818f, 15.784f, 5.771f, 15.883f, 5.727f)
                curveTo(16.239f, 5.569f, 16.521f, 5.444f, 16.521f, 5.062f)
                curveTo(16.521f, 4.596f, 16.093f, 4.365f, 15.632f, 4.115f)
                lineTo(15.573f, 4.083f)
                close()
                moveTo(17.813f, 4.293f)
                lineTo(17.572f, 4.572f)
                curveTo(17.78f, 4.776f, 17.786f, 5.105f, 17.734f, 5.289f)
                curveTo(17.682f, 5.47f, 17.546f, 5.581f, 17.266f, 5.638f)
                lineTo(17.32f, 6.014f)
                curveTo(17.437f, 5.99f, 17.551f, 5.974f, 17.658f, 5.959f)
                curveTo(18.044f, 5.905f, 18.35f, 5.862f, 18.455f, 5.496f)
                curveTo(18.583f, 5.047f, 18.236f, 4.707f, 17.861f, 4.34f)
                lineTo(17.813f, 4.293f)
                close()
                moveTo(19.608f, 5.322f)
                lineTo(19.921f, 5.126f)
                lineTo(19.953f, 5.185f)
                curveTo(20.204f, 5.646f, 20.436f, 6.073f, 20.182f, 6.464f)
                curveTo(19.975f, 6.784f, 19.67f, 6.735f, 19.285f, 6.674f)
                curveTo(19.178f, 6.657f, 19.065f, 6.639f, 18.946f, 6.628f)
                lineTo(19.004f, 6.253f)
                curveTo(19.288f, 6.28f, 19.451f, 6.214f, 19.553f, 6.055f)
                curveTo(19.657f, 5.895f, 19.747f, 5.579f, 19.608f, 5.322f)
                close()
                moveTo(21.692f, 6.515f)
                lineTo(21.337f, 6.618f)
                curveTo(21.4f, 6.902f, 21.226f, 7.182f, 21.082f, 7.307f)
                curveTo(20.94f, 7.431f, 20.766f, 7.45f, 20.5f, 7.346f)
                lineTo(20.34f, 7.69f)
                curveTo(20.452f, 7.733f, 20.556f, 7.782f, 20.654f, 7.828f)
                lineTo(20.654f, 7.828f)
                curveTo(21.007f, 7.993f, 21.286f, 8.124f, 21.574f, 7.873f)
                curveTo(21.926f, 7.567f, 21.82f, 7.093f, 21.706f, 6.581f)
                lineTo(21.692f, 6.515f)
                close()
                moveTo(22.631f, 8.346f)
                lineTo(23f, 8.345f)
                lineTo(22.996f, 8.412f)
                curveTo(22.965f, 8.936f, 22.936f, 9.421f, 22.514f, 9.619f)
                curveTo(22.168f, 9.78f, 21.935f, 9.577f, 21.641f, 9.321f)
                curveTo(21.559f, 9.25f, 21.473f, 9.175f, 21.378f, 9.102f)
                lineTo(21.626f, 8.815f)
                curveTo(21.853f, 8.989f, 22.025f, 9.019f, 22.197f, 8.939f)
                curveTo(22.369f, 8.858f, 22.614f, 8.637f, 22.631f, 8.346f)
                close()
                moveTo(23.751f, 10.483f)
                lineTo(23.398f, 10.376f)
                curveTo(23.296f, 10.649f, 22.998f, 10.789f, 22.809f, 10.816f)
                curveTo(22.622f, 10.842f, 22.465f, 10.763f, 22.299f, 10.531f)
                lineTo(21.978f, 10.733f)
                curveTo(22.048f, 10.83f, 22.108f, 10.927f, 22.166f, 11.019f)
                curveTo(22.372f, 11.35f, 22.535f, 11.612f, 22.913f, 11.559f)
                curveTo(23.375f, 11.494f, 23.545f, 11.038f, 23.728f, 10.546f)
                lineTo(23.751f, 10.483f)
                close()
                moveTo(23.551f, 12.531f)
                lineTo(23.861f, 12.731f)
                lineTo(23.822f, 12.785f)
                curveTo(23.51f, 13.208f, 23.221f, 13.599f, 22.76f, 13.534f)
                curveTo(22.382f, 13.481f, 22.297f, 13.184f, 22.19f, 12.81f)
                curveTo(22.16f, 12.705f, 22.128f, 12.595f, 22.088f, 12.482f)
                lineTo(22.453f, 12.377f)
                curveTo(22.548f, 12.646f, 22.677f, 12.765f, 22.864f, 12.791f)
                curveTo(23.053f, 12.818f, 23.378f, 12.765f, 23.551f, 12.531f)
                close()
                moveTo(23.336f, 14.936f)
                lineTo(23.098f, 14.654f)
                curveTo(22.863f, 14.827f, 22.537f, 14.782f, 22.364f, 14.702f)
                curveTo(22.193f, 14.622f, 22.105f, 14.47f, 22.092f, 14.185f)
                lineTo(21.713f, 14.179f)
                curveTo(21.718f, 14.299f, 21.716f, 14.414f, 21.714f, 14.522f)
                curveTo(21.707f, 14.911f, 21.701f, 15.22f, 22.047f, 15.381f)
                curveTo(22.47f, 15.578f, 22.86f, 15.289f, 23.282f, 14.976f)
                lineTo(23.336f, 14.936f)
                close()
                moveTo(22.061f, 16.55f)
                lineTo(22.212f, 16.886f)
                lineTo(22.149f, 16.91f)
                curveTo(21.658f, 17.094f, 21.202f, 17.265f, 20.851f, 16.959f)
                curveTo(20.563f, 16.709f, 20.653f, 16.414f, 20.767f, 16.042f)
                curveTo(20.799f, 15.938f, 20.833f, 15.828f, 20.861f, 15.712f)
                lineTo(21.224f, 15.822f)
                curveTo(21.157f, 16.1f, 21.2f, 16.27f, 21.343f, 16.393f)
                curveTo(21.487f, 16.518f, 21.788f, 16.652f, 22.061f, 16.55f)
                close()
                moveTo(20.586f, 18.442f)
                lineTo(20.533f, 18.077f)
                curveTo(20.243f, 18.1f, 19.99f, 17.889f, 19.886f, 17.729f)
                curveTo(19.783f, 17.57f, 19.789f, 17.395f, 19.929f, 17.146f)
                lineTo(19.611f, 16.941f)
                curveTo(19.552f, 17.045f, 19.489f, 17.141f, 19.43f, 17.232f)
                curveTo(19.218f, 17.558f, 19.049f, 17.817f, 19.257f, 18.137f)
                curveTo(19.511f, 18.528f, 19.996f, 18.489f, 20.519f, 18.447f)
                lineTo(20.586f, 18.442f)
                close()
                moveTo(18.632f, 19.124f)
                lineTo(18.575f, 19.489f)
                lineTo(18.51f, 19.474f)
                curveTo(17.997f, 19.361f, 17.523f, 19.257f, 17.394f, 18.809f)
                curveTo(17.289f, 18.442f, 17.526f, 18.243f, 17.824f, 17.993f)
                curveTo(17.907f, 17.924f, 17.995f, 17.85f, 18.082f, 17.768f)
                lineTo(18.326f, 18.058f)
                curveTo(18.12f, 18.254f, 18.063f, 18.42f, 18.115f, 18.602f)
                curveTo(18.168f, 18.785f, 18.348f, 19.061f, 18.632f, 19.124f)
                close()
                moveTo(16.366f, 19.917f)
                lineTo(16.521f, 19.582f)
                curveTo(16.265f, 19.443f, 16.168f, 19.128f, 16.168f, 18.938f)
                curveTo(16.168f, 18.749f, 16.268f, 18.605f, 16.521f, 18.473f)
                lineTo(16.366f, 18.127f)
                curveTo(16.26f, 18.182f, 16.155f, 18.229f, 16.056f, 18.273f)
                curveTo(15.7f, 18.431f, 15.418f, 18.556f, 15.418f, 18.938f)
                curveTo(15.418f, 19.404f, 15.845f, 19.635f, 16.307f, 19.885f)
                lineTo(16.366f, 19.917f)
                close()
                moveTo(14.367f, 19.428f)
                lineTo(14.125f, 19.707f)
                lineTo(14.077f, 19.66f)
                curveTo(13.703f, 19.293f, 13.355f, 18.953f, 13.484f, 18.504f)
                curveTo(13.589f, 18.138f, 13.895f, 18.095f, 14.28f, 18.041f)
                lineTo(14.28f, 18.041f)
                curveTo(14.388f, 18.026f, 14.502f, 18.01f, 14.619f, 17.986f)
                lineTo(14.673f, 18.362f)
                curveTo(14.393f, 18.419f, 14.257f, 18.53f, 14.205f, 18.711f)
                curveTo(14.152f, 18.895f, 14.159f, 19.224f, 14.367f, 19.428f)
                close()
                moveTo(12.018f, 18.874f)
                lineTo(12.33f, 18.678f)
                curveTo(12.191f, 18.421f, 12.281f, 18.104f, 12.385f, 17.945f)
                curveTo(12.488f, 17.786f, 12.65f, 17.72f, 12.935f, 17.747f)
                lineTo(12.993f, 17.372f)
                curveTo(12.874f, 17.361f, 12.76f, 17.343f, 12.653f, 17.326f)
                curveTo(12.269f, 17.265f, 11.964f, 17.216f, 11.756f, 17.536f)
                curveTo(11.502f, 17.927f, 11.735f, 18.354f, 11.986f, 18.815f)
                lineTo(12.018f, 18.874f)
                close()
                moveTo(10.601f, 17.382f)
                lineTo(10.247f, 17.485f)
                lineTo(10.232f, 17.42f)
                curveTo(10.118f, 16.907f, 10.012f, 16.433f, 10.364f, 16.127f)
                curveTo(10.652f, 15.876f, 10.932f, 16.007f, 11.285f, 16.172f)
                curveTo(11.383f, 16.218f, 11.487f, 16.267f, 11.598f, 16.31f)
                lineTo(11.439f, 16.654f)
                curveTo(11.173f, 16.55f, 10.999f, 16.569f, 10.856f, 16.693f)
                curveTo(10.712f, 16.818f, 10.538f, 17.098f, 10.601f, 17.382f)
                close()
                moveTo(8.938f, 15.655f)
                lineTo(9.307f, 15.654f)
                curveTo(9.325f, 15.363f, 9.569f, 15.142f, 9.742f, 15.061f)
                curveTo(9.913f, 14.981f, 10.086f, 15.011f, 10.313f, 15.185f)
                lineTo(10.561f, 14.898f)
                curveTo(10.466f, 14.825f, 10.379f, 14.75f, 10.297f, 14.679f)
                curveTo(10.004f, 14.423f, 9.771f, 14.22f, 9.425f, 14.381f)
                curveTo(9.002f, 14.578f, 8.973f, 15.064f, 8.942f, 15.588f)
                lineTo(8.938f, 15.655f)
                close()
                moveTo(8.541f, 13.624f)
                lineTo(8.187f, 13.516f)
                lineTo(8.211f, 13.454f)
                curveTo(8.394f, 12.962f, 8.564f, 12.506f, 9.025f, 12.441f)
                curveTo(9.403f, 12.388f, 9.567f, 12.65f, 9.773f, 12.98f)
                curveTo(9.83f, 13.073f, 9.891f, 13.17f, 9.961f, 13.267f)
                lineTo(9.639f, 13.469f)
                curveTo(9.473f, 13.237f, 9.317f, 13.158f, 9.13f, 13.184f)
                curveTo(8.941f, 13.21f, 8.643f, 13.351f, 8.541f, 13.624f)
                close()
                moveTo(8.077f, 11.269f)
                lineTo(8.387f, 11.469f)
                curveTo(8.561f, 11.235f, 8.886f, 11.182f, 9.075f, 11.209f)
                curveTo(9.262f, 11.235f, 9.39f, 11.354f, 9.486f, 11.623f)
                lineTo(9.85f, 11.518f)
                curveTo(9.81f, 11.405f, 9.779f, 11.295f, 9.749f, 11.19f)
                lineTo(9.749f, 11.19f)
                curveTo(9.642f, 10.816f, 9.557f, 10.519f, 9.179f, 10.466f)
                curveTo(8.717f, 10.401f, 8.429f, 10.792f, 8.117f, 11.215f)
                lineTo(8.077f, 11.269f)
                close()
                moveTo(8.841f, 9.346f)
                lineTo(8.603f, 9.064f)
                lineTo(8.657f, 9.024f)
                curveTo(9.078f, 8.711f, 9.469f, 8.422f, 9.891f, 8.619f)
                curveTo(10.237f, 8.78f, 10.232f, 9.089f, 10.224f, 9.478f)
                curveTo(10.222f, 9.586f, 10.22f, 9.701f, 10.226f, 9.821f)
                lineTo(9.846f, 9.815f)
                curveTo(9.834f, 9.53f, 9.745f, 9.378f, 9.574f, 9.298f)
                curveTo(9.402f, 9.218f, 9.075f, 9.173f, 8.841f, 9.346f)
                close()
                moveTo(9.727f, 7.113f)
                lineTo(9.878f, 7.45f)
                curveTo(10.151f, 7.348f, 10.452f, 7.481f, 10.596f, 7.607f)
                curveTo(10.738f, 7.73f, 10.781f, 7.9f, 10.715f, 8.178f)
                lineTo(11.078f, 8.288f)
                curveTo(11.106f, 8.172f, 11.139f, 8.062f, 11.171f, 7.958f)
                curveTo(11.285f, 7.586f, 11.376f, 7.291f, 11.088f, 7.041f)
                curveTo(10.736f, 6.735f, 10.281f, 6.905f, 9.79f, 7.09f)
                lineTo(9.727f, 7.113f)
                close()
                moveTo(11.405f, 5.923f)
                lineTo(11.353f, 5.558f)
                lineTo(11.42f, 5.553f)
                curveTo(11.943f, 5.511f, 12.427f, 5.472f, 12.682f, 5.863f)
                curveTo(12.889f, 6.183f, 12.721f, 6.442f, 12.509f, 6.768f)
                curveTo(12.45f, 6.859f, 12.387f, 6.955f, 12.328f, 7.06f)
                lineTo(12.009f, 6.854f)
                curveTo(12.15f, 6.605f, 12.155f, 6.43f, 12.052f, 6.271f)
                curveTo(11.949f, 6.111f, 11.696f, 5.9f, 11.405f, 5.923f)
                close()
                moveTo(13.363f, 4.511f)
                lineTo(13.306f, 4.876f)
                curveTo(13.591f, 4.939f, 13.771f, 5.215f, 13.823f, 5.398f)
                curveTo(13.875f, 5.58f, 13.819f, 5.746f, 13.612f, 5.942f)
                lineTo(13.857f, 6.232f)
                curveTo(13.943f, 6.15f, 14.031f, 6.076f, 14.115f, 6.006f)
                curveTo(14.413f, 5.757f, 14.65f, 5.558f, 14.545f, 5.191f)
                curveTo(14.416f, 4.743f, 13.941f, 4.639f, 13.429f, 4.526f)
                curveTo(13.407f, 4.521f, 13.385f, 4.516f, 13.363f, 4.511f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF247805)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.279f, 13.987f)
                curveTo(12.279f, 13.987f, 11.179f, 13.963f, 11.179f, 14.468f)
                curveTo(11.179f, 14.974f, 11.179f, 15.533f, 11.729f, 15.253f)
                curveTo(12.279f, 14.974f, 12.951f, 14.863f, 13.307f, 15.058f)
                curveTo(13.662f, 15.253f, 14.491f, 15.65f, 15.659f, 15.65f)
                curveTo(16.827f, 15.65f, 16.749f, 15.253f, 17.825f, 15.253f)
                curveTo(18.901f, 15.253f, 20.821f, 15.168f, 20.376f, 14.818f)
                curveTo(19.932f, 14.468f, 19.408f, 14.247f, 19.008f, 14.247f)
                curveTo(18.609f, 14.247f, 18.302f, 14.247f, 17.462f, 13.835f)
                curveTo(16.622f, 13.423f, 15.683f, 13.386f, 14.738f, 13.519f)
                curveTo(13.793f, 13.651f, 13.668f, 13.987f, 13.109f, 13.987f)
                curveTo(12.55f, 13.987f, 12.279f, 13.987f, 12.279f, 13.987f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                stroke = SolidColor(Color(0xFF565656)),
                strokeLineWidth = 0.5f
            ) {
                moveTo(16.1f, 15.65f)
                curveTo(16.171f, 15.89f, 16.171f, 15.89f, 16.171f, 15.89f)
                lineTo(16.171f, 15.89f)
                lineTo(16.172f, 15.889f)
                lineTo(16.174f, 15.889f)
                lineTo(16.18f, 15.887f)
                lineTo(16.2f, 15.881f)
                curveTo(16.217f, 15.875f, 16.241f, 15.867f, 16.272f, 15.856f)
                curveTo(16.332f, 15.834f, 16.417f, 15.801f, 16.519f, 15.756f)
                curveTo(16.721f, 15.666f, 16.992f, 15.524f, 17.264f, 15.319f)
                curveTo(17.809f, 14.908f, 18.376f, 14.228f, 18.376f, 13.192f)
                verticalLineTo(13.184f)
                verticalLineTo(13.176f)
                verticalLineTo(13.168f)
                verticalLineTo(13.16f)
                verticalLineTo(13.152f)
                verticalLineTo(13.144f)
                verticalLineTo(13.136f)
                verticalLineTo(13.128f)
                verticalLineTo(13.12f)
                verticalLineTo(13.112f)
                verticalLineTo(13.104f)
                verticalLineTo(13.097f)
                verticalLineTo(13.089f)
                verticalLineTo(13.081f)
                verticalLineTo(13.073f)
                verticalLineTo(13.065f)
                verticalLineTo(13.057f)
                verticalLineTo(13.049f)
                verticalLineTo(13.041f)
                verticalLineTo(13.034f)
                verticalLineTo(13.026f)
                verticalLineTo(13.018f)
                verticalLineTo(13.01f)
                verticalLineTo(13.002f)
                verticalLineTo(12.994f)
                verticalLineTo(12.987f)
                verticalLineTo(12.979f)
                verticalLineTo(12.971f)
                verticalLineTo(12.963f)
                verticalLineTo(12.955f)
                verticalLineTo(12.948f)
                verticalLineTo(12.94f)
                verticalLineTo(12.932f)
                verticalLineTo(12.924f)
                verticalLineTo(12.917f)
                verticalLineTo(12.909f)
                verticalLineTo(12.901f)
                verticalLineTo(12.893f)
                verticalLineTo(12.885f)
                verticalLineTo(12.878f)
                verticalLineTo(12.87f)
                verticalLineTo(12.862f)
                verticalLineTo(12.855f)
                verticalLineTo(12.847f)
                verticalLineTo(12.839f)
                verticalLineTo(12.832f)
                verticalLineTo(12.824f)
                verticalLineTo(12.816f)
                verticalLineTo(12.809f)
                verticalLineTo(12.801f)
                verticalLineTo(12.793f)
                verticalLineTo(12.785f)
                verticalLineTo(12.778f)
                verticalLineTo(12.77f)
                verticalLineTo(12.763f)
                verticalLineTo(12.755f)
                verticalLineTo(12.747f)
                verticalLineTo(12.74f)
                verticalLineTo(12.732f)
                verticalLineTo(12.725f)
                verticalLineTo(12.717f)
                verticalLineTo(12.71f)
                verticalLineTo(12.702f)
                verticalLineTo(12.694f)
                verticalLineTo(12.687f)
                verticalLineTo(12.679f)
                verticalLineTo(12.672f)
                verticalLineTo(12.664f)
                verticalLineTo(12.657f)
                verticalLineTo(12.649f)
                verticalLineTo(12.642f)
                verticalLineTo(12.634f)
                verticalLineTo(12.627f)
                verticalLineTo(12.619f)
                verticalLineTo(12.612f)
                verticalLineTo(12.604f)
                verticalLineTo(12.597f)
                verticalLineTo(12.589f)
                verticalLineTo(12.582f)
                verticalLineTo(12.575f)
                verticalLineTo(12.567f)
                verticalLineTo(12.56f)
                verticalLineTo(12.552f)
                verticalLineTo(12.545f)
                verticalLineTo(12.538f)
                verticalLineTo(12.53f)
                verticalLineTo(12.523f)
                verticalLineTo(12.516f)
                verticalLineTo(12.508f)
                verticalLineTo(12.501f)
                verticalLineTo(12.493f)
                verticalLineTo(12.486f)
                verticalLineTo(12.479f)
                verticalLineTo(12.472f)
                verticalLineTo(12.464f)
                verticalLineTo(12.457f)
                verticalLineTo(12.45f)
                verticalLineTo(12.442f)
                verticalLineTo(12.435f)
                verticalLineTo(12.428f)
                verticalLineTo(12.421f)
                verticalLineTo(12.413f)
                verticalLineTo(12.406f)
                verticalLineTo(12.399f)
                verticalLineTo(12.392f)
                verticalLineTo(12.385f)
                verticalLineTo(12.377f)
                verticalLineTo(12.37f)
                verticalLineTo(12.363f)
                verticalLineTo(12.356f)
                verticalLineTo(12.349f)
                verticalLineTo(12.342f)
                verticalLineTo(12.335f)
                verticalLineTo(12.327f)
                verticalLineTo(12.32f)
                verticalLineTo(12.313f)
                verticalLineTo(12.306f)
                verticalLineTo(12.299f)
                verticalLineTo(12.292f)
                verticalLineTo(12.285f)
                verticalLineTo(12.278f)
                verticalLineTo(12.271f)
                verticalLineTo(12.264f)
                verticalLineTo(12.257f)
                verticalLineTo(12.25f)
                verticalLineTo(12.243f)
                verticalLineTo(12.236f)
                verticalLineTo(12.229f)
                verticalLineTo(12.222f)
                verticalLineTo(12.215f)
                verticalLineTo(12.208f)
                verticalLineTo(12.201f)
                verticalLineTo(12.194f)
                verticalLineTo(12.187f)
                verticalLineTo(12.18f)
                verticalLineTo(12.173f)
                verticalLineTo(12.167f)
                verticalLineTo(12.16f)
                verticalLineTo(12.153f)
                verticalLineTo(12.146f)
                verticalLineTo(12.139f)
                verticalLineTo(12.132f)
                verticalLineTo(12.125f)
                verticalLineTo(12.119f)
                verticalLineTo(12.112f)
                verticalLineTo(12.105f)
                verticalLineTo(12.098f)
                verticalLineTo(12.092f)
                verticalLineTo(12.085f)
                verticalLineTo(12.078f)
                verticalLineTo(12.071f)
                verticalLineTo(12.065f)
                verticalLineTo(12.058f)
                verticalLineTo(12.051f)
                verticalLineTo(12.045f)
                verticalLineTo(12.038f)
                verticalLineTo(12.031f)
                verticalLineTo(12.025f)
                verticalLineTo(12.018f)
                verticalLineTo(12.011f)
                verticalLineTo(12.005f)
                verticalLineTo(11.998f)
                verticalLineTo(11.992f)
                verticalLineTo(11.985f)
                verticalLineTo(11.979f)
                verticalLineTo(11.972f)
                verticalLineTo(11.965f)
                verticalLineTo(11.959f)
                verticalLineTo(11.952f)
                verticalLineTo(11.946f)
                verticalLineTo(11.939f)
                verticalLineTo(11.933f)
                verticalLineTo(11.926f)
                verticalLineTo(11.92f)
                verticalLineTo(11.913f)
                verticalLineTo(11.907f)
                verticalLineTo(11.901f)
                verticalLineTo(11.894f)
                verticalLineTo(11.888f)
                verticalLineTo(11.882f)
                verticalLineTo(11.875f)
                verticalLineTo(11.869f)
                verticalLineTo(11.862f)
                verticalLineTo(11.856f)
                verticalLineTo(11.85f)
                verticalLineTo(11.843f)
                verticalLineTo(11.837f)
                verticalLineTo(11.831f)
                verticalLineTo(11.825f)
                verticalLineTo(11.818f)
                verticalLineTo(11.812f)
                verticalLineTo(11.806f)
                verticalLineTo(11.8f)
                verticalLineTo(11.793f)
                verticalLineTo(11.787f)
                verticalLineTo(11.781f)
                verticalLineTo(11.775f)
                verticalLineTo(11.769f)
                verticalLineTo(11.763f)
                verticalLineTo(11.757f)
                verticalLineTo(11.75f)
                verticalLineTo(11.744f)
                verticalLineTo(11.738f)
                verticalLineTo(11.732f)
                verticalLineTo(11.726f)
                verticalLineTo(11.72f)
                verticalLineTo(11.714f)
                verticalLineTo(11.708f)
                verticalLineTo(11.702f)
                verticalLineTo(11.696f)
                verticalLineTo(11.69f)
                verticalLineTo(11.684f)
                verticalLineTo(11.678f)
                verticalLineTo(11.672f)
                verticalLineTo(11.666f)
                verticalLineTo(11.66f)
                verticalLineTo(11.655f)
                verticalLineTo(11.649f)
                verticalLineTo(11.643f)
                verticalLineTo(11.637f)
                verticalLineTo(11.631f)
                verticalLineTo(11.625f)
                verticalLineTo(11.619f)
                verticalLineTo(11.614f)
                verticalLineTo(11.608f)
                verticalLineTo(11.602f)
                verticalLineTo(11.596f)
                verticalLineTo(11.591f)
                verticalLineTo(11.585f)
                verticalLineTo(11.579f)
                verticalLineTo(11.573f)
                verticalLineTo(11.568f)
                verticalLineTo(11.562f)
                verticalLineTo(11.557f)
                verticalLineTo(11.551f)
                verticalLineTo(11.545f)
                verticalLineTo(11.54f)
                verticalLineTo(11.534f)
                verticalLineTo(11.528f)
                verticalLineTo(11.523f)
                verticalLineTo(11.517f)
                verticalLineTo(11.512f)
                verticalLineTo(11.506f)
                verticalLineTo(11.501f)
                verticalLineTo(11.495f)
                verticalLineTo(11.49f)
                verticalLineTo(11.484f)
                verticalLineTo(11.479f)
                verticalLineTo(11.474f)
                verticalLineTo(11.468f)
                verticalLineTo(11.463f)
                verticalLineTo(11.457f)
                verticalLineTo(11.452f)
                verticalLineTo(11.447f)
                verticalLineTo(11.441f)
                verticalLineTo(11.436f)
                verticalLineTo(11.431f)
                verticalLineTo(11.425f)
                verticalLineTo(11.42f)
                verticalLineTo(11.415f)
                verticalLineTo(11.41f)
                verticalLineTo(11.405f)
                verticalLineTo(11.399f)
                verticalLineTo(11.394f)
                verticalLineTo(11.389f)
                verticalLineTo(11.384f)
                verticalLineTo(11.379f)
                verticalLineTo(11.373f)
                verticalLineTo(11.368f)
                verticalLineTo(11.363f)
                verticalLineTo(11.358f)
                verticalLineTo(11.353f)
                verticalLineTo(11.348f)
                verticalLineTo(11.343f)
                verticalLineTo(11.338f)
                verticalLineTo(11.333f)
                verticalLineTo(11.328f)
                verticalLineTo(11.323f)
                verticalLineTo(11.318f)
                verticalLineTo(11.313f)
                verticalLineTo(11.308f)
                verticalLineTo(11.303f)
                verticalLineTo(11.299f)
                verticalLineTo(11.294f)
                verticalLineTo(11.289f)
                verticalLineTo(11.284f)
                verticalLineTo(11.279f)
                verticalLineTo(11.274f)
                verticalLineTo(11.27f)
                verticalLineTo(11.265f)
                verticalLineTo(11.26f)
                verticalLineTo(11.255f)
                verticalLineTo(11.251f)
                verticalLineTo(11.246f)
                verticalLineTo(11.241f)
                verticalLineTo(11.237f)
                verticalLineTo(11.232f)
                verticalLineTo(11.227f)
                verticalLineTo(11.223f)
                verticalLineTo(11.218f)
                verticalLineTo(11.214f)
                verticalLineTo(11.209f)
                verticalLineTo(11.204f)
                verticalLineTo(11.2f)
                verticalLineTo(11.195f)
                verticalLineTo(11.191f)
                verticalLineTo(11.186f)
                verticalLineTo(11.182f)
                verticalLineTo(11.177f)
                verticalLineTo(11.173f)
                verticalLineTo(11.169f)
                verticalLineTo(11.164f)
                verticalLineTo(11.16f)
                verticalLineTo(11.156f)
                verticalLineTo(11.151f)
                verticalLineTo(11.147f)
                verticalLineTo(11.143f)
                verticalLineTo(11.138f)
                verticalLineTo(11.134f)
                verticalLineTo(11.13f)
                verticalLineTo(11.126f)
                verticalLineTo(11.122f)
                verticalLineTo(11.117f)
                verticalLineTo(11.113f)
                verticalLineTo(11.109f)
                verticalLineTo(11.105f)
                verticalLineTo(11.101f)
                verticalLineTo(11.097f)
                verticalLineTo(11.093f)
                verticalLineTo(11.089f)
                verticalLineTo(11.085f)
                verticalLineTo(11.08f)
                verticalLineTo(11.076f)
                verticalLineTo(11.073f)
                verticalLineTo(11.068f)
                verticalLineTo(11.065f)
                verticalLineTo(11.061f)
                verticalLineTo(11.057f)
                verticalLineTo(11.053f)
                verticalLineTo(11.049f)
                verticalLineTo(11.045f)
                verticalLineTo(11.041f)
                verticalLineTo(11.038f)
                verticalLineTo(11.034f)
                verticalLineTo(11.03f)
                verticalLineTo(11.026f)
                verticalLineTo(11.023f)
                verticalLineTo(11.019f)
                verticalLineTo(11.015f)
                verticalLineTo(11.011f)
                verticalLineTo(11.008f)
                verticalLineTo(11.004f)
                verticalLineTo(11f)
                verticalLineTo(10.997f)
                verticalLineTo(10.993f)
                verticalLineTo(10.99f)
                verticalLineTo(10.986f)
                verticalLineTo(10.983f)
                verticalLineTo(10.979f)
                verticalLineTo(10.976f)
                verticalLineTo(10.972f)
                verticalLineTo(10.969f)
                verticalLineTo(10.965f)
                verticalLineTo(10.962f)
                verticalLineTo(10.959f)
                verticalLineTo(10.955f)
                verticalLineTo(10.952f)
                verticalLineTo(10.948f)
                verticalLineTo(10.945f)
                verticalLineTo(10.942f)
                verticalLineTo(10.939f)
                verticalLineTo(10.936f)
                verticalLineTo(10.932f)
                verticalLineTo(10.929f)
                verticalLineTo(10.926f)
                verticalLineTo(10.923f)
                verticalLineTo(10.92f)
                verticalLineTo(10.916f)
                verticalLineTo(10.913f)
                verticalLineTo(10.91f)
                verticalLineTo(10.907f)
                verticalLineTo(10.904f)
                verticalLineTo(10.901f)
                verticalLineTo(10.898f)
                verticalLineTo(10.895f)
                verticalLineTo(10.892f)
                verticalLineTo(10.889f)
                verticalLineTo(10.886f)
                verticalLineTo(10.884f)
                verticalLineTo(10.881f)
                verticalLineTo(10.878f)
                verticalLineTo(10.875f)
                verticalLineTo(10.872f)
                verticalLineTo(10.869f)
                verticalLineTo(10.867f)
                verticalLineTo(10.864f)
                verticalLineTo(10.861f)
                verticalLineTo(10.858f)
                verticalLineTo(10.856f)
                verticalLineTo(10.853f)
                verticalLineTo(10.85f)
                verticalLineTo(10.848f)
                verticalLineTo(10.845f)
                verticalLineTo(10.843f)
                verticalLineTo(10.84f)
                verticalLineTo(10.838f)
                verticalLineTo(10.835f)
                verticalLineTo(10.833f)
                verticalLineTo(10.83f)
                verticalLineTo(10.828f)
                verticalLineTo(10.825f)
                verticalLineTo(10.823f)
                verticalLineTo(10.821f)
                verticalLineTo(10.818f)
                verticalLineTo(10.816f)
                verticalLineTo(10.814f)
                verticalLineTo(10.811f)
                verticalLineTo(10.809f)
                verticalLineTo(10.807f)
                verticalLineTo(10.804f)
                verticalLineTo(10.802f)
                verticalLineTo(10.8f)
                verticalLineTo(10.798f)
                verticalLineTo(10.796f)
                verticalLineTo(10.794f)
                verticalLineTo(10.792f)
                verticalLineTo(10.79f)
                verticalLineTo(10.787f)
                verticalLineTo(10.785f)
                verticalLineTo(10.783f)
                verticalLineTo(10.781f)
                verticalLineTo(10.78f)
                verticalLineTo(10.778f)
                verticalLineTo(10.776f)
                verticalLineTo(10.774f)
                verticalLineTo(10.772f)
                verticalLineTo(10.77f)
                verticalLineTo(10.768f)
                verticalLineTo(10.766f)
                verticalLineTo(10.765f)
                verticalLineTo(10.763f)
                verticalLineTo(10.761f)
                verticalLineTo(10.759f)
                verticalLineTo(10.758f)
                verticalLineTo(10.756f)
                verticalLineTo(10.755f)
                verticalLineTo(10.753f)
                verticalLineTo(10.751f)
                verticalLineTo(10.75f)
                verticalLineTo(10.748f)
                verticalLineTo(10.747f)
                verticalLineTo(10.745f)
                verticalLineTo(10.744f)
                verticalLineTo(10.742f)
                verticalLineTo(10.741f)
                verticalLineTo(10.74f)
                verticalLineTo(10.738f)
                verticalLineTo(10.737f)
                verticalLineTo(10.735f)
                verticalLineTo(10.734f)
                verticalLineTo(10.733f)
                verticalLineTo(10.732f)
                verticalLineTo(10.73f)
                verticalLineTo(10.729f)
                verticalLineTo(10.728f)
                verticalLineTo(10.727f)
                verticalLineTo(10.726f)
                verticalLineTo(10.724f)
                verticalLineTo(10.723f)
                verticalLineTo(10.722f)
                verticalLineTo(10.721f)
                verticalLineTo(10.72f)
                verticalLineTo(10.719f)
                verticalLineTo(10.718f)
                verticalLineTo(10.717f)
                verticalLineTo(10.717f)
                verticalLineTo(10.716f)
                verticalLineTo(10.715f)
                verticalLineTo(10.714f)
                verticalLineTo(10.713f)
                verticalLineTo(10.712f)
                verticalLineTo(10.712f)
                verticalLineTo(10.711f)
                verticalLineTo(10.71f)
                verticalLineTo(10.709f)
                verticalLineTo(10.709f)
                verticalLineTo(10.708f)
                verticalLineTo(10.707f)
                verticalLineTo(10.707f)
                verticalLineTo(10.706f)
                verticalLineTo(10.706f)
                verticalLineTo(10.705f)
                verticalLineTo(10.705f)
                verticalLineTo(10.704f)
                verticalLineTo(10.704f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.702f)
                verticalLineTo(10.702f)
                verticalLineTo(10.702f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                lineTo(18.126f, 10.7f)
                horizontalLineTo(18.376f)
                verticalLineTo(10.45f)
                horizontalLineTo(18.126f)
                horizontalLineTo(14.074f)
                horizontalLineTo(13.824f)
                verticalLineTo(10.7f)
                horizontalLineTo(14.074f)
                lineTo(13.824f, 10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.702f)
                verticalLineTo(10.702f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.704f)
                verticalLineTo(10.704f)
                verticalLineTo(10.705f)
                verticalLineTo(10.705f)
                verticalLineTo(10.706f)
                verticalLineTo(10.707f)
                verticalLineTo(10.707f)
                verticalLineTo(10.708f)
                verticalLineTo(10.709f)
                verticalLineTo(10.71f)
                verticalLineTo(10.71f)
                verticalLineTo(10.711f)
                verticalLineTo(10.712f)
                verticalLineTo(10.713f)
                verticalLineTo(10.714f)
                verticalLineTo(10.715f)
                verticalLineTo(10.715f)
                verticalLineTo(10.716f)
                verticalLineTo(10.717f)
                verticalLineTo(10.718f)
                verticalLineTo(10.719f)
                verticalLineTo(10.72f)
                verticalLineTo(10.722f)
                verticalLineTo(10.723f)
                verticalLineTo(10.724f)
                verticalLineTo(10.725f)
                verticalLineTo(10.726f)
                verticalLineTo(10.728f)
                verticalLineTo(10.729f)
                verticalLineTo(10.73f)
                verticalLineTo(10.731f)
                verticalLineTo(10.733f)
                verticalLineTo(10.734f)
                verticalLineTo(10.736f)
                verticalLineTo(10.737f)
                verticalLineTo(10.739f)
                verticalLineTo(10.74f)
                verticalLineTo(10.742f)
                verticalLineTo(10.743f)
                verticalLineTo(10.745f)
                verticalLineTo(10.746f)
                verticalLineTo(10.748f)
                verticalLineTo(10.75f)
                verticalLineTo(10.751f)
                verticalLineTo(10.753f)
                verticalLineTo(10.755f)
                verticalLineTo(10.757f)
                verticalLineTo(10.758f)
                verticalLineTo(10.76f)
                verticalLineTo(10.762f)
                verticalLineTo(10.764f)
                verticalLineTo(10.766f)
                verticalLineTo(10.768f)
                verticalLineTo(10.77f)
                verticalLineTo(10.772f)
                verticalLineTo(10.774f)
                verticalLineTo(10.776f)
                verticalLineTo(10.778f)
                verticalLineTo(10.78f)
                verticalLineTo(10.782f)
                verticalLineTo(10.784f)
                verticalLineTo(10.786f)
                verticalLineTo(10.788f)
                verticalLineTo(10.79f)
                verticalLineTo(10.793f)
                verticalLineTo(10.795f)
                verticalLineTo(10.797f)
                verticalLineTo(10.8f)
                verticalLineTo(10.802f)
                verticalLineTo(10.804f)
                verticalLineTo(10.807f)
                verticalLineTo(10.809f)
                verticalLineTo(10.811f)
                verticalLineTo(10.814f)
                verticalLineTo(10.816f)
                verticalLineTo(10.819f)
                verticalLineTo(10.821f)
                verticalLineTo(10.824f)
                verticalLineTo(10.827f)
                verticalLineTo(10.829f)
                verticalLineTo(10.832f)
                verticalLineTo(10.835f)
                verticalLineTo(10.837f)
                verticalLineTo(10.84f)
                verticalLineTo(10.843f)
                verticalLineTo(10.845f)
                verticalLineTo(10.848f)
                verticalLineTo(10.851f)
                verticalLineTo(10.854f)
                verticalLineTo(10.857f)
                verticalLineTo(10.859f)
                verticalLineTo(10.862f)
                verticalLineTo(10.865f)
                verticalLineTo(10.868f)
                verticalLineTo(10.871f)
                verticalLineTo(10.874f)
                verticalLineTo(10.877f)
                verticalLineTo(10.88f)
                verticalLineTo(10.883f)
                verticalLineTo(10.886f)
                verticalLineTo(10.889f)
                verticalLineTo(10.892f)
                verticalLineTo(10.896f)
                verticalLineTo(10.899f)
                verticalLineTo(10.902f)
                verticalLineTo(10.905f)
                verticalLineTo(10.908f)
                verticalLineTo(10.912f)
                verticalLineTo(10.915f)
                verticalLineTo(10.918f)
                verticalLineTo(10.922f)
                verticalLineTo(10.925f)
                verticalLineTo(10.928f)
                verticalLineTo(10.932f)
                verticalLineTo(10.935f)
                verticalLineTo(10.939f)
                verticalLineTo(10.942f)
                verticalLineTo(10.946f)
                verticalLineTo(10.949f)
                verticalLineTo(10.953f)
                verticalLineTo(10.956f)
                verticalLineTo(10.96f)
                verticalLineTo(10.963f)
                verticalLineTo(10.967f)
                verticalLineTo(10.97f)
                verticalLineTo(10.974f)
                verticalLineTo(10.978f)
                verticalLineTo(10.981f)
                verticalLineTo(10.985f)
                verticalLineTo(10.989f)
                verticalLineTo(10.993f)
                verticalLineTo(10.997f)
                verticalLineTo(11f)
                verticalLineTo(11.004f)
                verticalLineTo(11.008f)
                verticalLineTo(11.012f)
                verticalLineTo(11.016f)
                verticalLineTo(11.019f)
                verticalLineTo(11.023f)
                verticalLineTo(11.027f)
                verticalLineTo(11.031f)
                verticalLineTo(11.035f)
                verticalLineTo(11.039f)
                verticalLineTo(11.043f)
                verticalLineTo(11.047f)
                verticalLineTo(11.051f)
                verticalLineTo(11.056f)
                verticalLineTo(11.06f)
                verticalLineTo(11.064f)
                verticalLineTo(11.068f)
                verticalLineTo(11.072f)
                verticalLineTo(11.076f)
                verticalLineTo(11.08f)
                verticalLineTo(11.085f)
                verticalLineTo(11.089f)
                verticalLineTo(11.093f)
                verticalLineTo(11.097f)
                verticalLineTo(11.102f)
                verticalLineTo(11.106f)
                verticalLineTo(11.11f)
                verticalLineTo(11.115f)
                verticalLineTo(11.119f)
                verticalLineTo(11.123f)
                verticalLineTo(11.128f)
                verticalLineTo(11.132f)
                verticalLineTo(11.137f)
                verticalLineTo(11.141f)
                verticalLineTo(11.146f)
                verticalLineTo(11.15f)
                verticalLineTo(11.155f)
                verticalLineTo(11.159f)
                verticalLineTo(11.164f)
                verticalLineTo(11.168f)
                verticalLineTo(11.173f)
                verticalLineTo(11.177f)
                verticalLineTo(11.182f)
                verticalLineTo(11.187f)
                verticalLineTo(11.191f)
                verticalLineTo(11.196f)
                verticalLineTo(11.201f)
                verticalLineTo(11.205f)
                verticalLineTo(11.21f)
                verticalLineTo(11.215f)
                verticalLineTo(11.219f)
                verticalLineTo(11.224f)
                verticalLineTo(11.229f)
                verticalLineTo(11.234f)
                verticalLineTo(11.239f)
                verticalLineTo(11.243f)
                verticalLineTo(11.248f)
                verticalLineTo(11.253f)
                verticalLineTo(11.258f)
                verticalLineTo(11.263f)
                verticalLineTo(11.268f)
                verticalLineTo(11.273f)
                verticalLineTo(11.278f)
                verticalLineTo(11.283f)
                verticalLineTo(11.288f)
                verticalLineTo(11.293f)
                verticalLineTo(11.298f)
                verticalLineTo(11.303f)
                verticalLineTo(11.308f)
                verticalLineTo(11.313f)
                verticalLineTo(11.318f)
                verticalLineTo(11.323f)
                verticalLineTo(11.328f)
                verticalLineTo(11.333f)
                verticalLineTo(11.339f)
                verticalLineTo(11.344f)
                verticalLineTo(11.349f)
                verticalLineTo(11.354f)
                verticalLineTo(11.359f)
                verticalLineTo(11.365f)
                verticalLineTo(11.37f)
                verticalLineTo(11.375f)
                verticalLineTo(11.38f)
                verticalLineTo(11.386f)
                verticalLineTo(11.391f)
                verticalLineTo(11.396f)
                verticalLineTo(11.401f)
                verticalLineTo(11.407f)
                verticalLineTo(11.412f)
                verticalLineTo(11.418f)
                verticalLineTo(11.423f)
                verticalLineTo(11.428f)
                verticalLineTo(11.434f)
                verticalLineTo(11.439f)
                verticalLineTo(11.445f)
                verticalLineTo(11.45f)
                verticalLineTo(11.456f)
                verticalLineTo(11.461f)
                verticalLineTo(11.467f)
                verticalLineTo(11.472f)
                verticalLineTo(11.478f)
                verticalLineTo(11.483f)
                verticalLineTo(11.489f)
                verticalLineTo(11.494f)
                verticalLineTo(11.5f)
                verticalLineTo(11.505f)
                verticalLineTo(11.511f)
                verticalLineTo(11.517f)
                verticalLineTo(11.522f)
                verticalLineTo(11.528f)
                verticalLineTo(11.533f)
                verticalLineTo(11.539f)
                verticalLineTo(11.545f)
                verticalLineTo(11.551f)
                verticalLineTo(11.556f)
                verticalLineTo(11.562f)
                verticalLineTo(11.568f)
                verticalLineTo(11.573f)
                verticalLineTo(11.579f)
                verticalLineTo(11.585f)
                verticalLineTo(11.591f)
                verticalLineTo(11.597f)
                verticalLineTo(11.602f)
                verticalLineTo(11.608f)
                verticalLineTo(11.614f)
                verticalLineTo(11.62f)
                verticalLineTo(11.626f)
                verticalLineTo(11.632f)
                verticalLineTo(11.637f)
                verticalLineTo(11.643f)
                verticalLineTo(11.649f)
                verticalLineTo(11.655f)
                verticalLineTo(11.661f)
                verticalLineTo(11.667f)
                verticalLineTo(11.673f)
                verticalLineTo(11.679f)
                verticalLineTo(11.685f)
                verticalLineTo(11.691f)
                verticalLineTo(11.697f)
                verticalLineTo(11.703f)
                verticalLineTo(11.709f)
                verticalLineTo(11.715f)
                verticalLineTo(11.721f)
                verticalLineTo(11.727f)
                verticalLineTo(11.733f)
                verticalLineTo(11.739f)
                verticalLineTo(11.745f)
                verticalLineTo(11.751f)
                verticalLineTo(11.757f)
                verticalLineTo(11.764f)
                verticalLineTo(11.77f)
                verticalLineTo(11.776f)
                verticalLineTo(11.782f)
                verticalLineTo(11.788f)
                verticalLineTo(11.794f)
                verticalLineTo(11.8f)
                verticalLineTo(11.807f)
                verticalLineTo(11.813f)
                verticalLineTo(11.819f)
                verticalLineTo(11.825f)
                verticalLineTo(11.831f)
                verticalLineTo(11.838f)
                verticalLineTo(11.844f)
                verticalLineTo(11.85f)
                verticalLineTo(11.856f)
                verticalLineTo(11.863f)
                verticalLineTo(11.869f)
                verticalLineTo(11.875f)
                verticalLineTo(11.881f)
                verticalLineTo(11.888f)
                verticalLineTo(11.894f)
                verticalLineTo(11.9f)
                verticalLineTo(11.907f)
                verticalLineTo(11.913f)
                verticalLineTo(11.919f)
                verticalLineTo(11.926f)
                verticalLineTo(11.932f)
                verticalLineTo(11.938f)
                verticalLineTo(11.945f)
                verticalLineTo(11.951f)
                verticalLineTo(11.958f)
                verticalLineTo(11.964f)
                verticalLineTo(11.97f)
                verticalLineTo(11.977f)
                verticalLineTo(11.983f)
                verticalLineTo(11.99f)
                verticalLineTo(11.996f)
                verticalLineTo(12.002f)
                verticalLineTo(12.009f)
                verticalLineTo(12.015f)
                verticalLineTo(12.022f)
                verticalLineTo(12.028f)
                verticalLineTo(12.035f)
                verticalLineTo(12.041f)
                verticalLineTo(12.048f)
                verticalLineTo(12.054f)
                verticalLineTo(12.061f)
                verticalLineTo(12.067f)
                verticalLineTo(12.074f)
                verticalLineTo(12.08f)
                verticalLineTo(12.087f)
                verticalLineTo(12.094f)
                verticalLineTo(12.1f)
                verticalLineTo(12.107f)
                verticalLineTo(12.113f)
                verticalLineTo(12.12f)
                verticalLineTo(12.126f)
                verticalLineTo(12.133f)
                verticalLineTo(12.139f)
                verticalLineTo(12.146f)
                verticalLineTo(12.153f)
                verticalLineTo(12.159f)
                verticalLineTo(12.166f)
                verticalLineTo(12.172f)
                verticalLineTo(12.179f)
                verticalLineTo(12.186f)
                verticalLineTo(12.192f)
                verticalLineTo(12.199f)
                verticalLineTo(12.206f)
                verticalLineTo(12.212f)
                verticalLineTo(12.219f)
                verticalLineTo(12.226f)
                verticalLineTo(12.232f)
                verticalLineTo(12.239f)
                verticalLineTo(12.246f)
                verticalLineTo(12.252f)
                verticalLineTo(12.259f)
                verticalLineTo(12.266f)
                verticalLineTo(12.273f)
                verticalLineTo(12.279f)
                verticalLineTo(12.286f)
                verticalLineTo(12.293f)
                verticalLineTo(12.299f)
                verticalLineTo(12.306f)
                verticalLineTo(12.313f)
                verticalLineTo(12.319f)
                verticalLineTo(12.326f)
                verticalLineTo(12.333f)
                verticalLineTo(12.34f)
                verticalLineTo(12.347f)
                verticalLineTo(12.353f)
                verticalLineTo(12.36f)
                verticalLineTo(12.367f)
                verticalLineTo(12.373f)
                verticalLineTo(12.38f)
                verticalLineTo(12.387f)
                verticalLineTo(12.394f)
                verticalLineTo(12.401f)
                verticalLineTo(12.407f)
                verticalLineTo(12.414f)
                verticalLineTo(12.421f)
                verticalLineTo(12.428f)
                verticalLineTo(12.434f)
                verticalLineTo(12.441f)
                verticalLineTo(12.448f)
                verticalLineTo(12.455f)
                verticalLineTo(12.462f)
                verticalLineTo(12.469f)
                verticalLineTo(12.475f)
                verticalLineTo(12.482f)
                verticalLineTo(12.489f)
                verticalLineTo(12.496f)
                verticalLineTo(12.503f)
                verticalLineTo(12.509f)
                verticalLineTo(12.516f)
                verticalLineTo(12.523f)
                verticalLineTo(12.53f)
                verticalLineTo(12.537f)
                verticalLineTo(12.544f)
                verticalLineTo(12.55f)
                verticalLineTo(12.557f)
                verticalLineTo(12.564f)
                verticalLineTo(12.571f)
                verticalLineTo(12.578f)
                verticalLineTo(12.585f)
                verticalLineTo(12.592f)
                verticalLineTo(12.598f)
                verticalLineTo(12.605f)
                verticalLineTo(12.612f)
                verticalLineTo(12.619f)
                verticalLineTo(12.626f)
                verticalLineTo(12.633f)
                verticalLineTo(12.639f)
                verticalLineTo(12.646f)
                verticalLineTo(12.653f)
                verticalLineTo(12.66f)
                verticalLineTo(12.667f)
                verticalLineTo(12.674f)
                verticalLineTo(12.681f)
                verticalLineTo(12.687f)
                verticalLineTo(12.694f)
                verticalLineTo(12.701f)
                verticalLineTo(12.708f)
                verticalLineTo(12.715f)
                verticalLineTo(12.722f)
                verticalLineTo(12.729f)
                verticalLineTo(12.756f)
                verticalLineTo(12.811f)
                verticalLineTo(12.838f)
                verticalLineTo(12.852f)
                verticalLineTo(12.866f)
                verticalLineTo(12.893f)
                verticalLineTo(12.92f)
                verticalLineTo(12.948f)
                verticalLineTo(12.975f)
                verticalLineTo(13.03f)
                verticalLineTo(13.084f)
                verticalLineTo(13.111f)
                verticalLineTo(13.138f)
                verticalLineTo(13.192f)
                curveTo(13.824f, 14.202f, 14.393f, 14.882f, 14.935f, 15.297f)
                curveTo(15.206f, 15.505f, 15.476f, 15.652f, 15.677f, 15.746f)
                curveTo(15.778f, 15.794f, 15.863f, 15.829f, 15.923f, 15.852f)
                curveTo(15.953f, 15.863f, 15.977f, 15.872f, 15.995f, 15.878f)
                lineTo(16.015f, 15.885f)
                lineTo(16.021f, 15.887f)
                lineTo(16.022f, 15.888f)
                lineTo(16.023f, 15.888f)
                lineTo(16.023f, 15.888f)
                curveTo(16.024f, 15.888f, 16.024f, 15.888f, 16.1f, 15.65f)
                close()
                moveTo(16.1f, 15.65f)
                lineTo(16.171f, 15.89f)
                lineTo(16.097f, 15.912f)
                lineTo(16.024f, 15.888f)
                lineTo(16.1f, 15.65f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(16.1f, 15.65f)
                curveTo(16.171f, 15.89f, 16.171f, 15.89f, 16.171f, 15.89f)
                lineTo(16.171f, 15.89f)
                lineTo(16.172f, 15.889f)
                lineTo(16.174f, 15.889f)
                lineTo(16.18f, 15.887f)
                lineTo(16.2f, 15.881f)
                curveTo(16.217f, 15.875f, 16.241f, 15.867f, 16.272f, 15.856f)
                curveTo(16.332f, 15.834f, 16.417f, 15.801f, 16.519f, 15.756f)
                curveTo(16.721f, 15.666f, 16.992f, 15.524f, 17.264f, 15.319f)
                curveTo(17.809f, 14.908f, 18.376f, 14.228f, 18.376f, 13.192f)
                verticalLineTo(13.184f)
                verticalLineTo(13.176f)
                verticalLineTo(13.168f)
                verticalLineTo(13.16f)
                verticalLineTo(13.152f)
                verticalLineTo(13.144f)
                verticalLineTo(13.136f)
                verticalLineTo(13.128f)
                verticalLineTo(13.12f)
                verticalLineTo(13.112f)
                verticalLineTo(13.104f)
                verticalLineTo(13.097f)
                verticalLineTo(13.089f)
                verticalLineTo(13.081f)
                verticalLineTo(13.073f)
                verticalLineTo(13.065f)
                verticalLineTo(13.057f)
                verticalLineTo(13.049f)
                verticalLineTo(13.041f)
                verticalLineTo(13.034f)
                verticalLineTo(13.026f)
                verticalLineTo(13.018f)
                verticalLineTo(13.01f)
                verticalLineTo(13.002f)
                verticalLineTo(12.994f)
                verticalLineTo(12.987f)
                verticalLineTo(12.979f)
                verticalLineTo(12.971f)
                verticalLineTo(12.963f)
                verticalLineTo(12.955f)
                verticalLineTo(12.948f)
                verticalLineTo(12.94f)
                verticalLineTo(12.932f)
                verticalLineTo(12.924f)
                verticalLineTo(12.917f)
                verticalLineTo(12.909f)
                verticalLineTo(12.901f)
                verticalLineTo(12.893f)
                verticalLineTo(12.885f)
                verticalLineTo(12.878f)
                verticalLineTo(12.87f)
                verticalLineTo(12.862f)
                verticalLineTo(12.855f)
                verticalLineTo(12.847f)
                verticalLineTo(12.839f)
                verticalLineTo(12.832f)
                verticalLineTo(12.824f)
                verticalLineTo(12.816f)
                verticalLineTo(12.809f)
                verticalLineTo(12.801f)
                verticalLineTo(12.793f)
                verticalLineTo(12.785f)
                verticalLineTo(12.778f)
                verticalLineTo(12.77f)
                verticalLineTo(12.763f)
                verticalLineTo(12.755f)
                verticalLineTo(12.747f)
                verticalLineTo(12.74f)
                verticalLineTo(12.732f)
                verticalLineTo(12.725f)
                verticalLineTo(12.717f)
                verticalLineTo(12.71f)
                verticalLineTo(12.702f)
                verticalLineTo(12.694f)
                verticalLineTo(12.687f)
                verticalLineTo(12.679f)
                verticalLineTo(12.672f)
                verticalLineTo(12.664f)
                verticalLineTo(12.657f)
                verticalLineTo(12.649f)
                verticalLineTo(12.642f)
                verticalLineTo(12.634f)
                verticalLineTo(12.627f)
                verticalLineTo(12.619f)
                verticalLineTo(12.612f)
                verticalLineTo(12.604f)
                verticalLineTo(12.597f)
                verticalLineTo(12.589f)
                verticalLineTo(12.582f)
                verticalLineTo(12.575f)
                verticalLineTo(12.567f)
                verticalLineTo(12.56f)
                verticalLineTo(12.552f)
                verticalLineTo(12.545f)
                verticalLineTo(12.538f)
                verticalLineTo(12.53f)
                verticalLineTo(12.523f)
                verticalLineTo(12.516f)
                verticalLineTo(12.508f)
                verticalLineTo(12.501f)
                verticalLineTo(12.493f)
                verticalLineTo(12.486f)
                verticalLineTo(12.479f)
                verticalLineTo(12.472f)
                verticalLineTo(12.464f)
                verticalLineTo(12.457f)
                verticalLineTo(12.45f)
                verticalLineTo(12.442f)
                verticalLineTo(12.435f)
                verticalLineTo(12.428f)
                verticalLineTo(12.421f)
                verticalLineTo(12.413f)
                verticalLineTo(12.406f)
                verticalLineTo(12.399f)
                verticalLineTo(12.392f)
                verticalLineTo(12.385f)
                verticalLineTo(12.377f)
                verticalLineTo(12.37f)
                verticalLineTo(12.363f)
                verticalLineTo(12.356f)
                verticalLineTo(12.349f)
                verticalLineTo(12.342f)
                verticalLineTo(12.335f)
                verticalLineTo(12.327f)
                verticalLineTo(12.32f)
                verticalLineTo(12.313f)
                verticalLineTo(12.306f)
                verticalLineTo(12.299f)
                verticalLineTo(12.292f)
                verticalLineTo(12.285f)
                verticalLineTo(12.278f)
                verticalLineTo(12.271f)
                verticalLineTo(12.264f)
                verticalLineTo(12.257f)
                verticalLineTo(12.25f)
                verticalLineTo(12.243f)
                verticalLineTo(12.236f)
                verticalLineTo(12.229f)
                verticalLineTo(12.222f)
                verticalLineTo(12.215f)
                verticalLineTo(12.208f)
                verticalLineTo(12.201f)
                verticalLineTo(12.194f)
                verticalLineTo(12.187f)
                verticalLineTo(12.18f)
                verticalLineTo(12.173f)
                verticalLineTo(12.167f)
                verticalLineTo(12.16f)
                verticalLineTo(12.153f)
                verticalLineTo(12.146f)
                verticalLineTo(12.139f)
                verticalLineTo(12.132f)
                verticalLineTo(12.125f)
                verticalLineTo(12.119f)
                verticalLineTo(12.112f)
                verticalLineTo(12.105f)
                verticalLineTo(12.098f)
                verticalLineTo(12.092f)
                verticalLineTo(12.085f)
                verticalLineTo(12.078f)
                verticalLineTo(12.071f)
                verticalLineTo(12.065f)
                verticalLineTo(12.058f)
                verticalLineTo(12.051f)
                verticalLineTo(12.045f)
                verticalLineTo(12.038f)
                verticalLineTo(12.031f)
                verticalLineTo(12.025f)
                verticalLineTo(12.018f)
                verticalLineTo(12.011f)
                verticalLineTo(12.005f)
                verticalLineTo(11.998f)
                verticalLineTo(11.992f)
                verticalLineTo(11.985f)
                verticalLineTo(11.979f)
                verticalLineTo(11.972f)
                verticalLineTo(11.965f)
                verticalLineTo(11.959f)
                verticalLineTo(11.952f)
                verticalLineTo(11.946f)
                verticalLineTo(11.939f)
                verticalLineTo(11.933f)
                verticalLineTo(11.926f)
                verticalLineTo(11.92f)
                verticalLineTo(11.913f)
                verticalLineTo(11.907f)
                verticalLineTo(11.901f)
                verticalLineTo(11.894f)
                verticalLineTo(11.888f)
                verticalLineTo(11.882f)
                verticalLineTo(11.875f)
                verticalLineTo(11.869f)
                verticalLineTo(11.862f)
                verticalLineTo(11.856f)
                verticalLineTo(11.85f)
                verticalLineTo(11.843f)
                verticalLineTo(11.837f)
                verticalLineTo(11.831f)
                verticalLineTo(11.825f)
                verticalLineTo(11.818f)
                verticalLineTo(11.812f)
                verticalLineTo(11.806f)
                verticalLineTo(11.8f)
                verticalLineTo(11.793f)
                verticalLineTo(11.787f)
                verticalLineTo(11.781f)
                verticalLineTo(11.775f)
                verticalLineTo(11.769f)
                verticalLineTo(11.763f)
                verticalLineTo(11.757f)
                verticalLineTo(11.75f)
                verticalLineTo(11.744f)
                verticalLineTo(11.738f)
                verticalLineTo(11.732f)
                verticalLineTo(11.726f)
                verticalLineTo(11.72f)
                verticalLineTo(11.714f)
                verticalLineTo(11.708f)
                verticalLineTo(11.702f)
                verticalLineTo(11.696f)
                verticalLineTo(11.69f)
                verticalLineTo(11.684f)
                verticalLineTo(11.678f)
                verticalLineTo(11.672f)
                verticalLineTo(11.666f)
                verticalLineTo(11.66f)
                verticalLineTo(11.655f)
                verticalLineTo(11.649f)
                verticalLineTo(11.643f)
                verticalLineTo(11.637f)
                verticalLineTo(11.631f)
                verticalLineTo(11.625f)
                verticalLineTo(11.619f)
                verticalLineTo(11.614f)
                verticalLineTo(11.608f)
                verticalLineTo(11.602f)
                verticalLineTo(11.596f)
                verticalLineTo(11.591f)
                verticalLineTo(11.585f)
                verticalLineTo(11.579f)
                verticalLineTo(11.573f)
                verticalLineTo(11.568f)
                verticalLineTo(11.562f)
                verticalLineTo(11.557f)
                verticalLineTo(11.551f)
                verticalLineTo(11.545f)
                verticalLineTo(11.54f)
                verticalLineTo(11.534f)
                verticalLineTo(11.528f)
                verticalLineTo(11.523f)
                verticalLineTo(11.517f)
                verticalLineTo(11.512f)
                verticalLineTo(11.506f)
                verticalLineTo(11.501f)
                verticalLineTo(11.495f)
                verticalLineTo(11.49f)
                verticalLineTo(11.484f)
                verticalLineTo(11.479f)
                verticalLineTo(11.474f)
                verticalLineTo(11.468f)
                verticalLineTo(11.463f)
                verticalLineTo(11.457f)
                verticalLineTo(11.452f)
                verticalLineTo(11.447f)
                verticalLineTo(11.441f)
                verticalLineTo(11.436f)
                verticalLineTo(11.431f)
                verticalLineTo(11.425f)
                verticalLineTo(11.42f)
                verticalLineTo(11.415f)
                verticalLineTo(11.41f)
                verticalLineTo(11.405f)
                verticalLineTo(11.399f)
                verticalLineTo(11.394f)
                verticalLineTo(11.389f)
                verticalLineTo(11.384f)
                verticalLineTo(11.379f)
                verticalLineTo(11.373f)
                verticalLineTo(11.368f)
                verticalLineTo(11.363f)
                verticalLineTo(11.358f)
                verticalLineTo(11.353f)
                verticalLineTo(11.348f)
                verticalLineTo(11.343f)
                verticalLineTo(11.338f)
                verticalLineTo(11.333f)
                verticalLineTo(11.328f)
                verticalLineTo(11.323f)
                verticalLineTo(11.318f)
                verticalLineTo(11.313f)
                verticalLineTo(11.308f)
                verticalLineTo(11.303f)
                verticalLineTo(11.299f)
                verticalLineTo(11.294f)
                verticalLineTo(11.289f)
                verticalLineTo(11.284f)
                verticalLineTo(11.279f)
                verticalLineTo(11.274f)
                verticalLineTo(11.27f)
                verticalLineTo(11.265f)
                verticalLineTo(11.26f)
                verticalLineTo(11.255f)
                verticalLineTo(11.251f)
                verticalLineTo(11.246f)
                verticalLineTo(11.241f)
                verticalLineTo(11.237f)
                verticalLineTo(11.232f)
                verticalLineTo(11.227f)
                verticalLineTo(11.223f)
                verticalLineTo(11.218f)
                verticalLineTo(11.214f)
                verticalLineTo(11.209f)
                verticalLineTo(11.204f)
                verticalLineTo(11.2f)
                verticalLineTo(11.195f)
                verticalLineTo(11.191f)
                verticalLineTo(11.186f)
                verticalLineTo(11.182f)
                verticalLineTo(11.177f)
                verticalLineTo(11.173f)
                verticalLineTo(11.169f)
                verticalLineTo(11.164f)
                verticalLineTo(11.16f)
                verticalLineTo(11.156f)
                verticalLineTo(11.151f)
                verticalLineTo(11.147f)
                verticalLineTo(11.143f)
                verticalLineTo(11.138f)
                verticalLineTo(11.134f)
                verticalLineTo(11.13f)
                verticalLineTo(11.126f)
                verticalLineTo(11.122f)
                verticalLineTo(11.117f)
                verticalLineTo(11.113f)
                verticalLineTo(11.109f)
                verticalLineTo(11.105f)
                verticalLineTo(11.101f)
                verticalLineTo(11.097f)
                verticalLineTo(11.093f)
                verticalLineTo(11.089f)
                verticalLineTo(11.085f)
                verticalLineTo(11.08f)
                verticalLineTo(11.076f)
                verticalLineTo(11.073f)
                verticalLineTo(11.068f)
                verticalLineTo(11.065f)
                verticalLineTo(11.061f)
                verticalLineTo(11.057f)
                verticalLineTo(11.053f)
                verticalLineTo(11.049f)
                verticalLineTo(11.045f)
                verticalLineTo(11.041f)
                verticalLineTo(11.038f)
                verticalLineTo(11.034f)
                verticalLineTo(11.03f)
                verticalLineTo(11.026f)
                verticalLineTo(11.023f)
                verticalLineTo(11.019f)
                verticalLineTo(11.015f)
                verticalLineTo(11.011f)
                verticalLineTo(11.008f)
                verticalLineTo(11.004f)
                verticalLineTo(11f)
                verticalLineTo(10.997f)
                verticalLineTo(10.993f)
                verticalLineTo(10.99f)
                verticalLineTo(10.986f)
                verticalLineTo(10.983f)
                verticalLineTo(10.979f)
                verticalLineTo(10.976f)
                verticalLineTo(10.972f)
                verticalLineTo(10.969f)
                verticalLineTo(10.965f)
                verticalLineTo(10.962f)
                verticalLineTo(10.959f)
                verticalLineTo(10.955f)
                verticalLineTo(10.952f)
                verticalLineTo(10.948f)
                verticalLineTo(10.945f)
                verticalLineTo(10.942f)
                verticalLineTo(10.939f)
                verticalLineTo(10.936f)
                verticalLineTo(10.932f)
                verticalLineTo(10.929f)
                verticalLineTo(10.926f)
                verticalLineTo(10.923f)
                verticalLineTo(10.92f)
                verticalLineTo(10.916f)
                verticalLineTo(10.913f)
                verticalLineTo(10.91f)
                verticalLineTo(10.907f)
                verticalLineTo(10.904f)
                verticalLineTo(10.901f)
                verticalLineTo(10.898f)
                verticalLineTo(10.895f)
                verticalLineTo(10.892f)
                verticalLineTo(10.889f)
                verticalLineTo(10.886f)
                verticalLineTo(10.884f)
                verticalLineTo(10.881f)
                verticalLineTo(10.878f)
                verticalLineTo(10.875f)
                verticalLineTo(10.872f)
                verticalLineTo(10.869f)
                verticalLineTo(10.867f)
                verticalLineTo(10.864f)
                verticalLineTo(10.861f)
                verticalLineTo(10.858f)
                verticalLineTo(10.856f)
                verticalLineTo(10.853f)
                verticalLineTo(10.85f)
                verticalLineTo(10.848f)
                verticalLineTo(10.845f)
                verticalLineTo(10.843f)
                verticalLineTo(10.84f)
                verticalLineTo(10.838f)
                verticalLineTo(10.835f)
                verticalLineTo(10.833f)
                verticalLineTo(10.83f)
                verticalLineTo(10.828f)
                verticalLineTo(10.825f)
                verticalLineTo(10.823f)
                verticalLineTo(10.821f)
                verticalLineTo(10.818f)
                verticalLineTo(10.816f)
                verticalLineTo(10.814f)
                verticalLineTo(10.811f)
                verticalLineTo(10.809f)
                verticalLineTo(10.807f)
                verticalLineTo(10.804f)
                verticalLineTo(10.802f)
                verticalLineTo(10.8f)
                verticalLineTo(10.798f)
                verticalLineTo(10.796f)
                verticalLineTo(10.794f)
                verticalLineTo(10.792f)
                verticalLineTo(10.79f)
                verticalLineTo(10.787f)
                verticalLineTo(10.785f)
                verticalLineTo(10.783f)
                verticalLineTo(10.781f)
                verticalLineTo(10.78f)
                verticalLineTo(10.778f)
                verticalLineTo(10.776f)
                verticalLineTo(10.774f)
                verticalLineTo(10.772f)
                verticalLineTo(10.77f)
                verticalLineTo(10.768f)
                verticalLineTo(10.766f)
                verticalLineTo(10.765f)
                verticalLineTo(10.763f)
                verticalLineTo(10.761f)
                verticalLineTo(10.759f)
                verticalLineTo(10.758f)
                verticalLineTo(10.756f)
                verticalLineTo(10.755f)
                verticalLineTo(10.753f)
                verticalLineTo(10.751f)
                verticalLineTo(10.75f)
                verticalLineTo(10.748f)
                verticalLineTo(10.747f)
                verticalLineTo(10.745f)
                verticalLineTo(10.744f)
                verticalLineTo(10.742f)
                verticalLineTo(10.741f)
                verticalLineTo(10.74f)
                verticalLineTo(10.738f)
                verticalLineTo(10.737f)
                verticalLineTo(10.735f)
                verticalLineTo(10.734f)
                verticalLineTo(10.733f)
                verticalLineTo(10.732f)
                verticalLineTo(10.73f)
                verticalLineTo(10.729f)
                verticalLineTo(10.728f)
                verticalLineTo(10.727f)
                verticalLineTo(10.726f)
                verticalLineTo(10.724f)
                verticalLineTo(10.723f)
                verticalLineTo(10.722f)
                verticalLineTo(10.721f)
                verticalLineTo(10.72f)
                verticalLineTo(10.719f)
                verticalLineTo(10.718f)
                verticalLineTo(10.717f)
                verticalLineTo(10.717f)
                verticalLineTo(10.716f)
                verticalLineTo(10.715f)
                verticalLineTo(10.714f)
                verticalLineTo(10.713f)
                verticalLineTo(10.712f)
                verticalLineTo(10.712f)
                verticalLineTo(10.711f)
                verticalLineTo(10.71f)
                verticalLineTo(10.709f)
                verticalLineTo(10.709f)
                verticalLineTo(10.708f)
                verticalLineTo(10.707f)
                verticalLineTo(10.707f)
                verticalLineTo(10.706f)
                verticalLineTo(10.706f)
                verticalLineTo(10.705f)
                verticalLineTo(10.705f)
                verticalLineTo(10.704f)
                verticalLineTo(10.704f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.702f)
                verticalLineTo(10.702f)
                verticalLineTo(10.702f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                lineTo(18.126f, 10.7f)
                horizontalLineTo(18.376f)
                verticalLineTo(10.45f)
                horizontalLineTo(18.126f)
                horizontalLineTo(14.074f)
                horizontalLineTo(13.824f)
                verticalLineTo(10.7f)
                horizontalLineTo(14.074f)
                lineTo(13.824f, 10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.7f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.701f)
                verticalLineTo(10.702f)
                verticalLineTo(10.702f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.703f)
                verticalLineTo(10.704f)
                verticalLineTo(10.704f)
                verticalLineTo(10.705f)
                verticalLineTo(10.705f)
                verticalLineTo(10.706f)
                verticalLineTo(10.707f)
                verticalLineTo(10.707f)
                verticalLineTo(10.708f)
                verticalLineTo(10.709f)
                verticalLineTo(10.71f)
                verticalLineTo(10.71f)
                verticalLineTo(10.711f)
                verticalLineTo(10.712f)
                verticalLineTo(10.713f)
                verticalLineTo(10.714f)
                verticalLineTo(10.715f)
                verticalLineTo(10.715f)
                verticalLineTo(10.716f)
                verticalLineTo(10.717f)
                verticalLineTo(10.718f)
                verticalLineTo(10.719f)
                verticalLineTo(10.72f)
                verticalLineTo(10.722f)
                verticalLineTo(10.723f)
                verticalLineTo(10.724f)
                verticalLineTo(10.725f)
                verticalLineTo(10.726f)
                verticalLineTo(10.728f)
                verticalLineTo(10.729f)
                verticalLineTo(10.73f)
                verticalLineTo(10.731f)
                verticalLineTo(10.733f)
                verticalLineTo(10.734f)
                verticalLineTo(10.736f)
                verticalLineTo(10.737f)
                verticalLineTo(10.739f)
                verticalLineTo(10.74f)
                verticalLineTo(10.742f)
                verticalLineTo(10.743f)
                verticalLineTo(10.745f)
                verticalLineTo(10.746f)
                verticalLineTo(10.748f)
                verticalLineTo(10.75f)
                verticalLineTo(10.751f)
                verticalLineTo(10.753f)
                verticalLineTo(10.755f)
                verticalLineTo(10.757f)
                verticalLineTo(10.758f)
                verticalLineTo(10.76f)
                verticalLineTo(10.762f)
                verticalLineTo(10.764f)
                verticalLineTo(10.766f)
                verticalLineTo(10.768f)
                verticalLineTo(10.77f)
                verticalLineTo(10.772f)
                verticalLineTo(10.774f)
                verticalLineTo(10.776f)
                verticalLineTo(10.778f)
                verticalLineTo(10.78f)
                verticalLineTo(10.782f)
                verticalLineTo(10.784f)
                verticalLineTo(10.786f)
                verticalLineTo(10.788f)
                verticalLineTo(10.79f)
                verticalLineTo(10.793f)
                verticalLineTo(10.795f)
                verticalLineTo(10.797f)
                verticalLineTo(10.8f)
                verticalLineTo(10.802f)
                verticalLineTo(10.804f)
                verticalLineTo(10.807f)
                verticalLineTo(10.809f)
                verticalLineTo(10.811f)
                verticalLineTo(10.814f)
                verticalLineTo(10.816f)
                verticalLineTo(10.819f)
                verticalLineTo(10.821f)
                verticalLineTo(10.824f)
                verticalLineTo(10.827f)
                verticalLineTo(10.829f)
                verticalLineTo(10.832f)
                verticalLineTo(10.835f)
                verticalLineTo(10.837f)
                verticalLineTo(10.84f)
                verticalLineTo(10.843f)
                verticalLineTo(10.845f)
                verticalLineTo(10.848f)
                verticalLineTo(10.851f)
                verticalLineTo(10.854f)
                verticalLineTo(10.857f)
                verticalLineTo(10.859f)
                verticalLineTo(10.862f)
                verticalLineTo(10.865f)
                verticalLineTo(10.868f)
                verticalLineTo(10.871f)
                verticalLineTo(10.874f)
                verticalLineTo(10.877f)
                verticalLineTo(10.88f)
                verticalLineTo(10.883f)
                verticalLineTo(10.886f)
                verticalLineTo(10.889f)
                verticalLineTo(10.892f)
                verticalLineTo(10.896f)
                verticalLineTo(10.899f)
                verticalLineTo(10.902f)
                verticalLineTo(10.905f)
                verticalLineTo(10.908f)
                verticalLineTo(10.912f)
                verticalLineTo(10.915f)
                verticalLineTo(10.918f)
                verticalLineTo(10.922f)
                verticalLineTo(10.925f)
                verticalLineTo(10.928f)
                verticalLineTo(10.932f)
                verticalLineTo(10.935f)
                verticalLineTo(10.939f)
                verticalLineTo(10.942f)
                verticalLineTo(10.946f)
                verticalLineTo(10.949f)
                verticalLineTo(10.953f)
                verticalLineTo(10.956f)
                verticalLineTo(10.96f)
                verticalLineTo(10.963f)
                verticalLineTo(10.967f)
                verticalLineTo(10.97f)
                verticalLineTo(10.974f)
                verticalLineTo(10.978f)
                verticalLineTo(10.981f)
                verticalLineTo(10.985f)
                verticalLineTo(10.989f)
                verticalLineTo(10.993f)
                verticalLineTo(10.997f)
                verticalLineTo(11f)
                verticalLineTo(11.004f)
                verticalLineTo(11.008f)
                verticalLineTo(11.012f)
                verticalLineTo(11.016f)
                verticalLineTo(11.019f)
                verticalLineTo(11.023f)
                verticalLineTo(11.027f)
                verticalLineTo(11.031f)
                verticalLineTo(11.035f)
                verticalLineTo(11.039f)
                verticalLineTo(11.043f)
                verticalLineTo(11.047f)
                verticalLineTo(11.051f)
                verticalLineTo(11.056f)
                verticalLineTo(11.06f)
                verticalLineTo(11.064f)
                verticalLineTo(11.068f)
                verticalLineTo(11.072f)
                verticalLineTo(11.076f)
                verticalLineTo(11.08f)
                verticalLineTo(11.085f)
                verticalLineTo(11.089f)
                verticalLineTo(11.093f)
                verticalLineTo(11.097f)
                verticalLineTo(11.102f)
                verticalLineTo(11.106f)
                verticalLineTo(11.11f)
                verticalLineTo(11.115f)
                verticalLineTo(11.119f)
                verticalLineTo(11.123f)
                verticalLineTo(11.128f)
                verticalLineTo(11.132f)
                verticalLineTo(11.137f)
                verticalLineTo(11.141f)
                verticalLineTo(11.146f)
                verticalLineTo(11.15f)
                verticalLineTo(11.155f)
                verticalLineTo(11.159f)
                verticalLineTo(11.164f)
                verticalLineTo(11.168f)
                verticalLineTo(11.173f)
                verticalLineTo(11.177f)
                verticalLineTo(11.182f)
                verticalLineTo(11.187f)
                verticalLineTo(11.191f)
                verticalLineTo(11.196f)
                verticalLineTo(11.201f)
                verticalLineTo(11.205f)
                verticalLineTo(11.21f)
                verticalLineTo(11.215f)
                verticalLineTo(11.219f)
                verticalLineTo(11.224f)
                verticalLineTo(11.229f)
                verticalLineTo(11.234f)
                verticalLineTo(11.239f)
                verticalLineTo(11.243f)
                verticalLineTo(11.248f)
                verticalLineTo(11.253f)
                verticalLineTo(11.258f)
                verticalLineTo(11.263f)
                verticalLineTo(11.268f)
                verticalLineTo(11.273f)
                verticalLineTo(11.278f)
                verticalLineTo(11.283f)
                verticalLineTo(11.288f)
                verticalLineTo(11.293f)
                verticalLineTo(11.298f)
                verticalLineTo(11.303f)
                verticalLineTo(11.308f)
                verticalLineTo(11.313f)
                verticalLineTo(11.318f)
                verticalLineTo(11.323f)
                verticalLineTo(11.328f)
                verticalLineTo(11.333f)
                verticalLineTo(11.339f)
                verticalLineTo(11.344f)
                verticalLineTo(11.349f)
                verticalLineTo(11.354f)
                verticalLineTo(11.359f)
                verticalLineTo(11.365f)
                verticalLineTo(11.37f)
                verticalLineTo(11.375f)
                verticalLineTo(11.38f)
                verticalLineTo(11.386f)
                verticalLineTo(11.391f)
                verticalLineTo(11.396f)
                verticalLineTo(11.401f)
                verticalLineTo(11.407f)
                verticalLineTo(11.412f)
                verticalLineTo(11.418f)
                verticalLineTo(11.423f)
                verticalLineTo(11.428f)
                verticalLineTo(11.434f)
                verticalLineTo(11.439f)
                verticalLineTo(11.445f)
                verticalLineTo(11.45f)
                verticalLineTo(11.456f)
                verticalLineTo(11.461f)
                verticalLineTo(11.467f)
                verticalLineTo(11.472f)
                verticalLineTo(11.478f)
                verticalLineTo(11.483f)
                verticalLineTo(11.489f)
                verticalLineTo(11.494f)
                verticalLineTo(11.5f)
                verticalLineTo(11.505f)
                verticalLineTo(11.511f)
                verticalLineTo(11.517f)
                verticalLineTo(11.522f)
                verticalLineTo(11.528f)
                verticalLineTo(11.533f)
                verticalLineTo(11.539f)
                verticalLineTo(11.545f)
                verticalLineTo(11.551f)
                verticalLineTo(11.556f)
                verticalLineTo(11.562f)
                verticalLineTo(11.568f)
                verticalLineTo(11.573f)
                verticalLineTo(11.579f)
                verticalLineTo(11.585f)
                verticalLineTo(11.591f)
                verticalLineTo(11.597f)
                verticalLineTo(11.602f)
                verticalLineTo(11.608f)
                verticalLineTo(11.614f)
                verticalLineTo(11.62f)
                verticalLineTo(11.626f)
                verticalLineTo(11.632f)
                verticalLineTo(11.637f)
                verticalLineTo(11.643f)
                verticalLineTo(11.649f)
                verticalLineTo(11.655f)
                verticalLineTo(11.661f)
                verticalLineTo(11.667f)
                verticalLineTo(11.673f)
                verticalLineTo(11.679f)
                verticalLineTo(11.685f)
                verticalLineTo(11.691f)
                verticalLineTo(11.697f)
                verticalLineTo(11.703f)
                verticalLineTo(11.709f)
                verticalLineTo(11.715f)
                verticalLineTo(11.721f)
                verticalLineTo(11.727f)
                verticalLineTo(11.733f)
                verticalLineTo(11.739f)
                verticalLineTo(11.745f)
                verticalLineTo(11.751f)
                verticalLineTo(11.757f)
                verticalLineTo(11.764f)
                verticalLineTo(11.77f)
                verticalLineTo(11.776f)
                verticalLineTo(11.782f)
                verticalLineTo(11.788f)
                verticalLineTo(11.794f)
                verticalLineTo(11.8f)
                verticalLineTo(11.807f)
                verticalLineTo(11.813f)
                verticalLineTo(11.819f)
                verticalLineTo(11.825f)
                verticalLineTo(11.831f)
                verticalLineTo(11.838f)
                verticalLineTo(11.844f)
                verticalLineTo(11.85f)
                verticalLineTo(11.856f)
                verticalLineTo(11.863f)
                verticalLineTo(11.869f)
                verticalLineTo(11.875f)
                verticalLineTo(11.881f)
                verticalLineTo(11.888f)
                verticalLineTo(11.894f)
                verticalLineTo(11.9f)
                verticalLineTo(11.907f)
                verticalLineTo(11.913f)
                verticalLineTo(11.919f)
                verticalLineTo(11.926f)
                verticalLineTo(11.932f)
                verticalLineTo(11.938f)
                verticalLineTo(11.945f)
                verticalLineTo(11.951f)
                verticalLineTo(11.958f)
                verticalLineTo(11.964f)
                verticalLineTo(11.97f)
                verticalLineTo(11.977f)
                verticalLineTo(11.983f)
                verticalLineTo(11.99f)
                verticalLineTo(11.996f)
                verticalLineTo(12.002f)
                verticalLineTo(12.009f)
                verticalLineTo(12.015f)
                verticalLineTo(12.022f)
                verticalLineTo(12.028f)
                verticalLineTo(12.035f)
                verticalLineTo(12.041f)
                verticalLineTo(12.048f)
                verticalLineTo(12.054f)
                verticalLineTo(12.061f)
                verticalLineTo(12.067f)
                verticalLineTo(12.074f)
                verticalLineTo(12.08f)
                verticalLineTo(12.087f)
                verticalLineTo(12.094f)
                verticalLineTo(12.1f)
                verticalLineTo(12.107f)
                verticalLineTo(12.113f)
                verticalLineTo(12.12f)
                verticalLineTo(12.126f)
                verticalLineTo(12.133f)
                verticalLineTo(12.139f)
                verticalLineTo(12.146f)
                verticalLineTo(12.153f)
                verticalLineTo(12.159f)
                verticalLineTo(12.166f)
                verticalLineTo(12.172f)
                verticalLineTo(12.179f)
                verticalLineTo(12.186f)
                verticalLineTo(12.192f)
                verticalLineTo(12.199f)
                verticalLineTo(12.206f)
                verticalLineTo(12.212f)
                verticalLineTo(12.219f)
                verticalLineTo(12.226f)
                verticalLineTo(12.232f)
                verticalLineTo(12.239f)
                verticalLineTo(12.246f)
                verticalLineTo(12.252f)
                verticalLineTo(12.259f)
                verticalLineTo(12.266f)
                verticalLineTo(12.273f)
                verticalLineTo(12.279f)
                verticalLineTo(12.286f)
                verticalLineTo(12.293f)
                verticalLineTo(12.299f)
                verticalLineTo(12.306f)
                verticalLineTo(12.313f)
                verticalLineTo(12.319f)
                verticalLineTo(12.326f)
                verticalLineTo(12.333f)
                verticalLineTo(12.34f)
                verticalLineTo(12.347f)
                verticalLineTo(12.353f)
                verticalLineTo(12.36f)
                verticalLineTo(12.367f)
                verticalLineTo(12.373f)
                verticalLineTo(12.38f)
                verticalLineTo(12.387f)
                verticalLineTo(12.394f)
                verticalLineTo(12.401f)
                verticalLineTo(12.407f)
                verticalLineTo(12.414f)
                verticalLineTo(12.421f)
                verticalLineTo(12.428f)
                verticalLineTo(12.434f)
                verticalLineTo(12.441f)
                verticalLineTo(12.448f)
                verticalLineTo(12.455f)
                verticalLineTo(12.462f)
                verticalLineTo(12.469f)
                verticalLineTo(12.475f)
                verticalLineTo(12.482f)
                verticalLineTo(12.489f)
                verticalLineTo(12.496f)
                verticalLineTo(12.503f)
                verticalLineTo(12.509f)
                verticalLineTo(12.516f)
                verticalLineTo(12.523f)
                verticalLineTo(12.53f)
                verticalLineTo(12.537f)
                verticalLineTo(12.544f)
                verticalLineTo(12.55f)
                verticalLineTo(12.557f)
                verticalLineTo(12.564f)
                verticalLineTo(12.571f)
                verticalLineTo(12.578f)
                verticalLineTo(12.585f)
                verticalLineTo(12.592f)
                verticalLineTo(12.598f)
                verticalLineTo(12.605f)
                verticalLineTo(12.612f)
                verticalLineTo(12.619f)
                verticalLineTo(12.626f)
                verticalLineTo(12.633f)
                verticalLineTo(12.639f)
                verticalLineTo(12.646f)
                verticalLineTo(12.653f)
                verticalLineTo(12.66f)
                verticalLineTo(12.667f)
                verticalLineTo(12.674f)
                verticalLineTo(12.681f)
                verticalLineTo(12.687f)
                verticalLineTo(12.694f)
                verticalLineTo(12.701f)
                verticalLineTo(12.708f)
                verticalLineTo(12.715f)
                verticalLineTo(12.722f)
                verticalLineTo(12.729f)
                verticalLineTo(12.756f)
                verticalLineTo(12.811f)
                verticalLineTo(12.838f)
                verticalLineTo(12.852f)
                verticalLineTo(12.866f)
                verticalLineTo(12.893f)
                verticalLineTo(12.92f)
                verticalLineTo(12.948f)
                verticalLineTo(12.975f)
                verticalLineTo(13.03f)
                verticalLineTo(13.084f)
                verticalLineTo(13.111f)
                verticalLineTo(13.138f)
                verticalLineTo(13.192f)
                curveTo(13.824f, 14.202f, 14.393f, 14.882f, 14.935f, 15.297f)
                curveTo(15.206f, 15.505f, 15.476f, 15.652f, 15.677f, 15.746f)
                curveTo(15.778f, 15.794f, 15.863f, 15.829f, 15.923f, 15.852f)
                curveTo(15.953f, 15.863f, 15.977f, 15.872f, 15.995f, 15.878f)
                lineTo(16.015f, 15.885f)
                lineTo(16.021f, 15.887f)
                lineTo(16.022f, 15.888f)
                lineTo(16.023f, 15.888f)
                lineTo(16.023f, 15.888f)
                curveTo(16.024f, 15.888f, 16.024f, 15.888f, 16.1f, 15.65f)
                close()
                moveTo(16.1f, 15.65f)
                lineTo(16.171f, 15.89f)
                lineTo(16.097f, 15.912f)
                lineTo(16.024f, 15.888f)
                lineTo(16.1f, 15.65f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF84CEFF)),
                fillAlpha = 0.4f,
                strokeAlpha = 0.4f,
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.197f, 13.909f)
                lineTo(16.13f, 12.485f)
                lineTo(18.163f, 14.07f)
                verticalLineTo(16.327f)
                horizontalLineTo(14.197f)
                verticalLineTo(13.909f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF006AC9)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.258f, 14.413f)
                horizontalLineTo(17.85f)
                verticalLineTo(14.913f)
                horizontalLineTo(14.258f)
                verticalLineTo(14.413f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF59C800)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.442f, 14.908f)
                horizontalLineTo(17.758f)
                verticalLineTo(15.173f)
                horizontalLineTo(14.442f)
                verticalLineTo(14.908f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD800)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.442f, 15.238f)
                horizontalLineTo(17.758f)
                verticalLineTo(15.738f)
                horizontalLineTo(14.442f)
                verticalLineTo(15.238f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7D85D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(18.726f, 14.511f)
                lineTo(16.136f, 12.533f)
                lineTo(16.136f, 9.862f)
                horizontalLineTo(18.726f)
                verticalLineTo(14.511f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF5F6F6)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.547f, 13.422f)
                curveTo(15.547f, 13.422f, 15.629f, 13.847f, 15.692f, 13.847f)
                curveTo(15.755f, 13.847f, 15.868f, 13.422f, 15.868f, 13.422f)
                curveTo(15.868f, 13.422f, 15.881f, 13.847f, 15.944f, 13.847f)
                curveTo(16.007f, 13.847f, 15.999f, 13.491f, 16.1f, 13.422f)
                curveTo(16.136f, 13.398f, 16.182f, 13.845f, 16.238f, 13.847f)
                curveTo(16.285f, 13.849f, 16.4f, 13.422f, 16.4f, 13.422f)
                curveTo(16.4f, 13.422f, 16.435f, 13.847f, 16.49f, 13.847f)
                curveTo(16.544f, 13.847f, 16.653f, 13.422f, 16.653f, 13.422f)
                verticalLineTo(14.495f)
                horizontalLineTo(15.547f)
                verticalLineTo(13.422f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF892E2E)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.1f, 14.84f)
                curveTo(16.66f, 14.84f, 17.113f, 14.744f, 17.113f, 14.626f)
                curveTo(17.113f, 14.508f, 16.66f, 14.413f, 16.1f, 14.413f)
                curveTo(15.54f, 14.413f, 15.087f, 14.508f, 15.087f, 14.626f)
                curveTo(15.087f, 14.744f, 15.54f, 14.84f, 16.1f, 14.84f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA46031))) {
                moveTo(14.289f, 11.104f)
                lineTo(14.498f, 10.941f)
                lineTo(15.899f, 12.381f)
                lineTo(15.69f, 12.544f)
                lineTo(14.289f, 11.104f)
                close()
            }
            path(fill = SolidColor(Color(0xFF892E2E))) {
                moveTo(14.515f, 12.767f)
                lineTo(14.293f, 12.619f)
                lineTo(15.656f, 10.988f)
                lineTo(15.877f, 11.136f)
                lineTo(14.515f, 12.767f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA46031))) {
                moveTo(16.408f, 11.318f)
                lineTo(16.616f, 11.189f)
                lineTo(18.017f, 12.332f)
                lineTo(17.809f, 12.461f)
                lineTo(16.408f, 11.318f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF5F6F6))) {
                moveTo(16.701f, 12.486f)
                lineTo(16.442f, 12.31f)
                lineTo(17.774f, 11.236f)
                lineTo(18.058f, 11.469f)
                lineTo(16.701f, 12.486f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF6699FF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(14.567f, 16.535f)
            lineTo(15.217f, 16.739f)
            verticalLineTo(17.3f)
            horizontalLineTo(14.567f)
            verticalLineTo(16.535f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF6699FF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(14.102f, 15.387f)
            lineTo(14.468f, 15.591f)
            verticalLineTo(16.152f)
            horizontalLineTo(14.102f)
            verticalLineTo(15.387f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF6699FF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(17.54f, 16.535f)
            lineTo(16.89f, 16.739f)
            verticalLineTo(17.3f)
            horizontalLineTo(17.54f)
            verticalLineTo(16.535f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF6699FF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(18.005f, 15.387f)
            lineTo(17.639f, 15.591f)
            verticalLineTo(16.152f)
            horizontalLineTo(18.005f)
            verticalLineTo(15.387f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(13.748f, 16.576f)
            curveTo(13.629f, 16.576f, 13.53f, 16.579f, 13.416f, 16.584f)
            curveTo(13.142f, 16.597f, 13.125f, 16.597f, 13.049f, 16.566f)
            curveTo(13.003f, 16.547f, 12.958f, 16.517f, 12.892f, 16.463f)
            curveTo(12.737f, 16.336f, 12.57f, 16.044f, 12.389f, 15.585f)
            lineTo(12.389f, 15.565f)
            curveTo(12.613f, 15.081f, 13.074f, 15.021f, 13.758f, 15.38f)
            curveTo(13.939f, 15.475f, 14.465f, 15.76f, 14.46f, 15.758f)
            curveTo(14.7f, 15.886f, 14.868f, 15.968f, 15.032f, 16.035f)
            curveTo(15.374f, 16.172f, 15.696f, 16.235f, 16.11f, 16.235f)
            curveTo(16.358f, 16.235f, 16.646f, 16.164f, 16.981f, 16.031f)
            curveTo(17.175f, 15.954f, 17.376f, 15.86f, 17.622f, 15.735f)
            curveTo(17.655f, 15.719f, 18.17f, 15.451f, 18.297f, 15.39f)
            curveTo(18.52f, 15.283f, 18.667f, 15.231f, 18.768f, 15.231f)
            curveTo(18.795f, 15.231f, 18.817f, 15.231f, 18.87f, 15.23f)
            curveTo(18.963f, 15.23f, 19.007f, 15.23f, 19.06f, 15.23f)
            curveTo(19.554f, 15.236f, 19.797f, 15.318f, 19.797f, 15.576f)
            curveTo(19.797f, 15.818f, 19.639f, 16.148f, 19.324f, 16.567f)
            lineTo(19.309f, 16.576f)
            curveTo(18.686f, 16.66f, 18.324f, 16.66f, 18.213f, 16.571f)
            curveTo(18.183f, 16.547f, 18.1f, 16.558f, 17.947f, 16.607f)
            curveTo(17.878f, 16.629f, 17.507f, 16.761f, 17.393f, 16.799f)
            curveTo(16.917f, 16.957f, 16.508f, 17.042f, 16.092f, 17.042f)
            curveTo(15.459f, 17.042f, 14.766f, 16.797f, 14.012f, 16.306f)
            curveTo(14.149f, 16.479f, 14.062f, 16.576f, 13.748f, 16.576f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF666666)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(13.416f, 16.584f)
            curveTo(13.53f, 16.579f, 13.629f, 16.576f, 13.748f, 16.576f)
            curveTo(14.062f, 16.576f, 14.149f, 16.479f, 14.012f, 16.306f)
            curveTo(14.766f, 16.797f, 15.459f, 17.042f, 16.092f, 17.042f)
            curveTo(16.508f, 17.042f, 16.917f, 16.957f, 17.393f, 16.799f)
            curveTo(17.451f, 16.78f, 17.576f, 16.736f, 17.693f, 16.695f)
            curveTo(17.806f, 16.655f, 17.913f, 16.618f, 17.947f, 16.607f)
            curveTo(18.1f, 16.558f, 18.183f, 16.547f, 18.213f, 16.571f)
            curveTo(18.324f, 16.66f, 18.686f, 16.66f, 19.309f, 16.576f)
            lineTo(19.324f, 16.567f)
            curveTo(19.639f, 16.148f, 19.797f, 15.818f, 19.797f, 15.576f)
            curveTo(19.797f, 15.318f, 19.554f, 15.236f, 19.06f, 15.23f)
            curveTo(19.007f, 15.23f, 18.963f, 15.23f, 18.87f, 15.23f)
            curveTo(18.817f, 15.231f, 18.795f, 15.231f, 18.768f, 15.231f)
            curveTo(18.667f, 15.231f, 18.52f, 15.283f, 18.297f, 15.39f)
            curveTo(18.196f, 15.438f, 17.853f, 15.616f, 17.698f, 15.696f)
            curveTo(17.657f, 15.717f, 17.629f, 15.732f, 17.622f, 15.735f)
            curveTo(17.376f, 15.86f, 17.175f, 15.954f, 16.981f, 16.031f)
            curveTo(16.646f, 16.164f, 16.358f, 16.235f, 16.11f, 16.235f)
            curveTo(15.696f, 16.235f, 15.374f, 16.172f, 15.032f, 16.035f)
            curveTo(14.868f, 15.968f, 14.7f, 15.886f, 14.46f, 15.758f)
            curveTo(14.465f, 15.76f, 13.939f, 15.475f, 13.758f, 15.38f)
            curveTo(13.074f, 15.021f, 12.613f, 15.081f, 12.389f, 15.565f)
            lineTo(12.389f, 15.585f)
            curveTo(12.57f, 16.044f, 12.737f, 16.336f, 12.892f, 16.463f)
            curveTo(12.958f, 16.517f, 13.003f, 16.547f, 13.049f, 16.566f)
            curveTo(13.125f, 16.597f, 13.142f, 16.597f, 13.416f, 16.584f)
            close()
            moveTo(13.066f, 16.522f)
            curveTo(13.026f, 16.505f, 12.983f, 16.477f, 12.921f, 16.426f)
            curveTo(12.775f, 16.306f, 12.613f, 16.022f, 12.436f, 15.576f)
            curveTo(12.648f, 15.13f, 13.078f, 15.077f, 13.737f, 15.423f)
            curveTo(13.917f, 15.517f, 14.443f, 15.803f, 14.439f, 15.801f)
            curveTo(14.68f, 15.929f, 14.849f, 16.012f, 15.015f, 16.079f)
            curveTo(15.363f, 16.219f, 15.691f, 16.282f, 16.11f, 16.282f)
            curveTo(16.365f, 16.282f, 16.657f, 16.211f, 16.998f, 16.076f)
            curveTo(17.193f, 15.998f, 17.396f, 15.903f, 17.643f, 15.778f)
            curveTo(17.65f, 15.774f, 17.678f, 15.76f, 17.72f, 15.738f)
            curveTo(17.876f, 15.658f, 18.217f, 15.481f, 18.317f, 15.433f)
            curveTo(18.533f, 15.329f, 18.676f, 15.278f, 18.768f, 15.278f)
            curveTo(18.795f, 15.278f, 18.817f, 15.278f, 18.87f, 15.278f)
            curveTo(18.963f, 15.277f, 19.007f, 15.277f, 19.059f, 15.278f)
            curveTo(19.527f, 15.284f, 19.751f, 15.359f, 19.751f, 15.576f)
            curveTo(19.751f, 15.804f, 19.599f, 16.122f, 19.294f, 16.53f)
            curveTo(18.692f, 16.61f, 18.338f, 16.61f, 18.242f, 16.533f)
            curveTo(18.194f, 16.495f, 18.103f, 16.507f, 17.933f, 16.561f)
            curveTo(17.899f, 16.572f, 17.791f, 16.61f, 17.677f, 16.65f)
            curveTo(17.56f, 16.691f, 17.436f, 16.735f, 17.379f, 16.754f)
            curveTo(16.906f, 16.91f, 16.503f, 16.994f, 16.092f, 16.994f)
            curveTo(15.392f, 16.994f, 14.615f, 16.689f, 13.761f, 16.076f)
            lineTo(13.734f, 16.115f)
            curveTo(14.124f, 16.408f, 14.124f, 16.528f, 13.748f, 16.528f)
            curveTo(13.628f, 16.528f, 13.528f, 16.531f, 13.414f, 16.537f)
            curveTo(13.149f, 16.549f, 13.132f, 16.549f, 13.066f, 16.522f)
            close()
        }
        path(fill = SolidColor(Color(0xFF565757))) {
            moveTo(13.028f, 15.809f)
            lineTo(12.961f, 15.742f)
            curveTo(13.113f, 15.579f, 13.313f, 15.538f, 13.555f, 15.618f)
            curveTo(13.649f, 15.649f, 14.262f, 16.003f, 14.425f, 16.086f)
            curveTo(15.023f, 16.39f, 15.592f, 16.559f, 16.197f, 16.559f)
            curveTo(17.066f, 16.559f, 17.905f, 16.285f, 18.713f, 15.738f)
            curveTo(19.018f, 15.49f, 19.209f, 15.49f, 19.209f, 15.775f)
            horizontalLineTo(19.116f)
            curveTo(19.116f, 15.605f, 19.027f, 15.605f, 18.767f, 15.815f)
            curveTo(17.942f, 16.375f, 17.085f, 16.655f, 16.197f, 16.655f)
            curveTo(15.576f, 16.655f, 14.994f, 16.482f, 14.384f, 16.172f)
            curveTo(14.213f, 16.085f, 13.61f, 15.737f, 13.527f, 15.709f)
            curveTo(13.317f, 15.64f, 13.154f, 15.673f, 13.028f, 15.809f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF984800)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(16.49f, 6.944f)
            lineTo(16.309f, 6.944f)
            curveTo(16.314f, 7.687f, 16.147f, 8.156f, 15.824f, 8.358f)
            curveTo(15.798f, 8.373f, 15.766f, 8.392f, 15.731f, 8.413f)
            curveTo(15.701f, 8.33f, 15.661f, 8.231f, 15.61f, 8.106f)
            lineTo(15.594f, 8.066f)
            curveTo(15.402f, 7.593f, 15.359f, 7.375f, 15.458f, 7.317f)
            lineTo(15.36f, 7.177f)
            curveTo(15.142f, 7.306f, 15.189f, 7.545f, 15.424f, 8.124f)
            lineTo(15.441f, 8.164f)
            curveTo(15.499f, 8.307f, 15.542f, 8.416f, 15.573f, 8.503f)
            lineTo(15.554f, 8.514f)
            lineTo(15.554f, 8.514f)
            lineTo(15.554f, 8.514f)
            curveTo(15.544f, 8.519f, 15.534f, 8.525f, 15.525f, 8.53f)
            curveTo(15.431f, 8.482f, 15.322f, 8.458f, 15.198f, 8.458f)
            curveTo(14.622f, 8.458f, 14.224f, 8.307f, 13.992f, 8.009f)
            lineTo(13.844f, 8.105f)
            curveTo(14.114f, 8.452f, 14.568f, 8.624f, 15.198f, 8.624f)
            curveTo(15.25f, 8.624f, 15.298f, 8.63f, 15.343f, 8.643f)
            curveTo(15.251f, 8.721f, 15.239f, 8.803f, 15.239f, 9.084f)
            curveTo(15.239f, 9.261f, 15.277f, 9.494f, 15.353f, 9.787f)
            curveTo(15.294f, 9.712f, 15.24f, 9.676f, 15.184f, 9.676f)
            verticalLineTo(9.842f)
            curveTo(15.176f, 9.842f, 15.171f, 9.841f, 15.169f, 9.841f)
            lineTo(15.168f, 9.84f)
            lineTo(15.167f, 9.84f)
            lineTo(15.166f, 9.839f)
            lineTo(15.168f, 9.841f)
            lineTo(15.168f, 9.84f)
            curveTo(15.174f, 9.845f, 15.181f, 9.852f, 15.19f, 9.863f)
            curveTo(15.216f, 9.892f, 15.247f, 9.94f, 15.282f, 10.004f)
            curveTo(15.355f, 10.139f, 15.446f, 10.344f, 15.552f, 10.619f)
            lineTo(15.608f, 10.6f)
            lineTo(15.612f, 10.613f)
            lineTo(15.642f, 10.604f)
            verticalLineTo(10.609f)
            horizontalLineTo(15.699f)
            lineTo(15.7f, 10.655f)
            lineTo(15.881f, 10.651f)
            curveTo(15.881f, 10.634f, 15.88f, 10.616f, 15.88f, 10.599f)
            lineTo(15.914f, 10.603f)
            curveTo(15.951f, 10.332f, 15.972f, 10.086f, 15.978f, 9.865f)
            curveTo(16.042f, 9.689f, 16.135f, 9.562f, 16.258f, 9.483f)
            curveTo(16.567f, 9.284f, 16.748f, 9.092f, 16.797f, 8.902f)
            lineTo(16.622f, 8.864f)
            curveTo(16.584f, 9.006f, 16.43f, 9.169f, 16.154f, 9.347f)
            curveTo(16.086f, 9.391f, 16.025f, 9.445f, 15.973f, 9.51f)
            curveTo(15.955f, 9.237f, 15.906f, 9.016f, 15.823f, 8.849f)
            verticalLineTo(8.8f)
            curveTo(15.823f, 8.733f, 15.813f, 8.667f, 15.787f, 8.577f)
            curveTo(15.838f, 8.547f, 15.887f, 8.519f, 15.925f, 8.495f)
            curveTo(16.311f, 8.255f, 16.495f, 7.736f, 16.49f, 6.944f)
            close()
            moveTo(15.513f, 8.732f)
            curveTo(15.562f, 8.773f, 15.606f, 8.826f, 15.642f, 8.892f)
            verticalLineTo(10.139f)
            curveTo(15.494f, 9.669f, 15.42f, 9.316f, 15.42f, 9.084f)
            curveTo(15.42f, 8.824f, 15.427f, 8.791f, 15.487f, 8.748f)
            curveTo(15.491f, 8.745f, 15.5f, 8.739f, 15.513f, 8.732f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF247805)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(16.983f, 7.085f)
            curveTo(16.847f, 7.125f, 16.671f, 7.135f, 16.485f, 7.106f)
            curveTo(16.278f, 7.073f, 16.1f, 6.999f, 15.981f, 6.906f)
            curveTo(15.988f, 6.929f, 15.992f, 6.953f, 15.991f, 6.977f)
            curveTo(15.987f, 7.206f, 15.62f, 7.386f, 15.17f, 7.378f)
            curveTo(14.72f, 7.37f, 14.359f, 7.178f, 14.363f, 6.948f)
            curveTo(14.367f, 6.719f, 14.735f, 6.54f, 15.185f, 6.548f)
            curveTo(15.455f, 6.552f, 15.693f, 6.624f, 15.84f, 6.73f)
            curveTo(15.827f, 6.695f, 15.823f, 6.659f, 15.828f, 6.624f)
            curveTo(15.861f, 6.42f, 16.207f, 6.305f, 16.601f, 6.368f)
            curveTo(16.996f, 6.43f, 17.29f, 6.646f, 17.258f, 6.85f)
            curveTo(17.252f, 6.887f, 17.236f, 6.921f, 17.211f, 6.952f)
            curveTo(17.405f, 6.896f, 17.673f, 6.909f, 17.946f, 7.003f)
            curveTo(18.419f, 7.166f, 18.729f, 7.508f, 18.639f, 7.769f)
            curveTo(18.55f, 8.029f, 18.094f, 8.108f, 17.622f, 7.945f)
            curveTo(17.565f, 7.925f, 17.511f, 7.903f, 17.459f, 7.879f)
            curveTo(17.331f, 8.077f, 16.974f, 8.181f, 16.578f, 8.119f)
            curveTo(16.109f, 8.044f, 15.764f, 7.764f, 15.807f, 7.492f)
            curveTo(15.85f, 7.22f, 16.265f, 7.06f, 16.734f, 7.135f)
            curveTo(16.802f, 7.145f, 16.867f, 7.16f, 16.929f, 7.179f)
            curveTo(16.941f, 7.145f, 16.959f, 7.113f, 16.983f, 7.085f)
            close()
            moveTo(14.273f, 6.984f)
            curveTo(14.373f, 7.164f, 14.171f, 7.468f, 13.821f, 7.662f)
            curveTo(13.472f, 7.855f, 13.107f, 7.866f, 13.007f, 7.686f)
            curveTo(12.907f, 7.505f, 13.11f, 7.202f, 13.459f, 7.008f)
            curveTo(13.809f, 6.814f, 14.173f, 6.804f, 14.273f, 6.984f)
            close()
            moveTo(15.367f, 8.118f)
            curveTo(15.362f, 8.37f, 14.913f, 8.567f, 14.364f, 8.557f)
            curveTo(13.814f, 8.548f, 13.372f, 8.336f, 13.377f, 8.083f)
            curveTo(13.381f, 7.831f, 13.83f, 7.635f, 14.38f, 7.644f)
            curveTo(14.929f, 7.654f, 15.371f, 7.866f, 15.367f, 8.118f)
            close()
            moveTo(14.733f, 9.882f)
            curveTo(15.229f, 9.821f, 15.609f, 9.587f, 15.581f, 9.36f)
            curveTo(15.553f, 9.132f, 15.128f, 8.997f, 14.632f, 9.058f)
            curveTo(14.137f, 9.119f, 13.757f, 9.352f, 13.785f, 9.58f)
            curveTo(13.813f, 9.808f, 14.238f, 9.943f, 14.733f, 9.882f)
            close()
            moveTo(16.563f, 10.186f)
            curveTo(17.001f, 10.287f, 17.402f, 10.169f, 17.458f, 9.924f)
            curveTo(17.515f, 9.678f, 17.206f, 9.397f, 16.768f, 9.296f)
            curveTo(16.33f, 9.195f, 15.929f, 9.312f, 15.872f, 9.557f)
            curveTo(15.815f, 9.803f, 16.124f, 10.084f, 16.563f, 10.186f)
            close()
            moveTo(16.949f, 9.253f)
            curveTo(17.611f, 9.381f, 18.187f, 9.285f, 18.235f, 9.038f)
            curveTo(18.283f, 8.79f, 17.785f, 8.485f, 17.123f, 8.356f)
            curveTo(16.461f, 8.228f, 15.885f, 8.324f, 15.837f, 8.571f)
            curveTo(15.789f, 8.819f, 16.287f, 9.124f, 16.949f, 9.253f)
            close()
        }
        path(
            fill = SolidColor(Color.White),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(12.245f, 10.939f)
            curveTo(12.245f, 10.939f, 11.932f, 13.909f, 11.932f, 14.312f)
            curveTo(11.932f, 14.715f, 12.508f, 14.312f, 12.508f, 14.312f)
            curveTo(12.508f, 14.312f, 12.593f, 12.894f, 12.789f, 12.367f)
            curveTo(12.985f, 11.84f, 13.077f, 12.419f, 13.077f, 12.726f)
            curveTo(13.077f, 13.034f, 13.077f, 14.473f, 13.077f, 14.473f)
            curveTo(13.077f, 14.473f, 13.794f, 14.571f, 13.794f, 14.312f)
            curveTo(13.794f, 14.053f, 13.496f, 10.939f, 13.496f, 10.939f)
            horizontalLineTo(12.412f)
            horizontalLineTo(12.245f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF979797)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(12.205f, 10.898f)
            lineTo(12.201f, 10.935f)
            curveTo(11.992f, 12.918f, 11.888f, 14.041f, 11.888f, 14.312f)
            curveTo(11.888f, 14.63f, 12.127f, 14.63f, 12.534f, 14.345f)
            lineTo(12.551f, 14.334f)
            lineTo(12.552f, 14.314f)
            curveTo(12.608f, 13.372f, 12.701f, 12.727f, 12.83f, 12.38f)
            curveTo(12.908f, 12.172f, 12.931f, 12.162f, 12.965f, 12.248f)
            curveTo(13.006f, 12.349f, 13.033f, 12.554f, 13.033f, 12.726f)
            verticalLineTo(14.509f)
            lineTo(13.071f, 14.514f)
            curveTo(13.574f, 14.583f, 13.838f, 14.523f, 13.838f, 14.312f)
            curveTo(13.838f, 14.201f, 13.786f, 13.589f, 13.698f, 12.63f)
            lineTo(13.689f, 12.525f)
            curveTo(13.656f, 12.17f, 13.621f, 11.796f, 13.586f, 11.426f)
            lineTo(13.552f, 11.07f)
            lineTo(13.543f, 10.97f)
            lineTo(13.54f, 10.936f)
            lineTo(13.536f, 10.898f)
            horizontalLineTo(12.205f)
            close()
            moveTo(12.465f, 14.29f)
            curveTo(12.117f, 14.53f, 11.976f, 14.527f, 11.976f, 14.312f)
            curveTo(11.976f, 14.047f, 12.079f, 12.935f, 12.285f, 10.981f)
            horizontalLineTo(13.455f)
            lineTo(13.465f, 11.077f)
            lineTo(13.498f, 11.434f)
            curveTo(13.533f, 11.804f, 13.568f, 12.177f, 13.601f, 12.532f)
            lineTo(13.611f, 12.638f)
            curveTo(13.698f, 13.589f, 13.75f, 14.205f, 13.75f, 14.312f)
            curveTo(13.75f, 14.442f, 13.548f, 14.491f, 13.121f, 14.437f)
            verticalLineTo(12.726f)
            curveTo(13.121f, 12.545f, 13.093f, 12.331f, 13.048f, 12.218f)
            curveTo(12.972f, 12.033f, 12.847f, 12.085f, 12.747f, 12.353f)
            curveTo(12.616f, 12.706f, 12.522f, 13.351f, 12.465f, 14.29f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFF863B)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(11.207f, 9.918f)
            curveTo(11.207f, 9.918f, 11.452f, 10.802f, 11.561f, 10.802f)
            curveTo(11.67f, 10.802f, 12.33f, 10.259f, 12.33f, 10.259f)
            verticalLineTo(10.996f)
            horizontalLineTo(13.561f)
            verticalLineTo(10.67f)
            lineTo(13.718f, 10.996f)
            lineTo(13.933f, 10.896f)
            lineTo(14.306f, 10.457f)
            horizontalLineTo(13.933f)
            curveTo(13.933f, 10.457f, 13.825f, 9.752f, 13.825f, 9.641f)
            curveTo(13.825f, 9.53f, 13.83f, 9.309f, 13.561f, 9.23f)
            curveTo(13.291f, 9.15f, 13.159f, 9.009f, 13.159f, 9.009f)
            curveTo(13.159f, 9.009f, 13.739f, 8.178f, 13.297f, 8.178f)
            curveTo(12.856f, 8.178f, 12.656f, 8.285f, 12.656f, 8.285f)
            curveTo(12.656f, 8.285f, 12.656f, 8.778f, 12.656f, 8.893f)
            curveTo(12.656f, 9.009f, 12.023f, 8.872f, 12.023f, 9.23f)
            curveTo(12.023f, 9.587f, 11.728f, 9.918f, 11.728f, 9.918f)
            lineTo(11.653f, 9.678f)
            lineTo(11.207f, 9.918f)
            close()
        }
        path(
            fill = SolidColor(Color.Black),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(13.067f, 8.383f)
            curveTo(13.31f, 8.383f, 13.507f, 8.286f, 13.507f, 8.166f)
            curveTo(13.507f, 8.047f, 13.31f, 7.95f, 13.067f, 7.95f)
            curveTo(12.824f, 7.95f, 12.626f, 8.047f, 12.626f, 8.166f)
            curveTo(12.626f, 8.286f, 12.824f, 8.383f, 13.067f, 8.383f)
            close()
        }
        path(fill = SolidColor(Color(0xFF740000))) {
            moveTo(10.847f, 10.26f)
            lineTo(10.648f, 10.095f)
            curveTo(11.031f, 9.68f, 11.458f, 9.378f, 11.927f, 9.191f)
            curveTo(12.371f, 9.014f, 12.951f, 8.731f, 13.666f, 8.342f)
            lineTo(13.798f, 8.56f)
            curveTo(13.074f, 8.953f, 12.485f, 9.24f, 12.029f, 9.422f)
            curveTo(11.599f, 9.594f, 11.205f, 9.873f, 10.847f, 10.26f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF9FCFF)),
            stroke = SolidColor(Color(0xFF6C6C6C)),
            strokeLineWidth = 0.5f,
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(13.658f, 8.433f)
            lineTo(13.825f, 9.217f)
            lineTo(14.566f, 8.825f)
            lineTo(13.982f, 8.176f)
            lineTo(13.658f, 8.433f)
            close()
        }
        path(
            fill = SolidColor(Color.White),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(19.859f, 11.307f)
            curveTo(19.859f, 11.307f, 20.17f, 14.407f, 20.17f, 14.827f)
            curveTo(20.17f, 15.247f, 19.598f, 14.827f, 19.598f, 14.827f)
            curveTo(19.598f, 14.827f, 19.514f, 13.347f, 19.32f, 12.797f)
            curveTo(19.125f, 12.247f, 19.034f, 12.851f, 19.034f, 13.172f)
            curveTo(19.034f, 13.493f, 19.034f, 14.995f, 19.034f, 14.995f)
            curveTo(19.034f, 14.995f, 18.323f, 15.097f, 18.323f, 14.827f)
            curveTo(18.323f, 14.557f, 18.619f, 11.307f, 18.619f, 11.307f)
            horizontalLineTo(19.694f)
            horizontalLineTo(19.859f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF979797)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(19.899f, 11.263f)
            lineTo(19.903f, 11.303f)
            curveTo(20.11f, 13.372f, 20.213f, 14.545f, 20.213f, 14.827f)
            curveTo(20.213f, 15.159f, 19.977f, 15.159f, 19.573f, 14.862f)
            lineTo(19.556f, 14.85f)
            lineTo(19.555f, 14.83f)
            curveTo(19.499f, 13.847f, 19.407f, 13.173f, 19.279f, 12.811f)
            curveTo(19.202f, 12.593f, 19.179f, 12.584f, 19.145f, 12.673f)
            curveTo(19.104f, 12.778f, 19.077f, 12.993f, 19.077f, 13.172f)
            verticalLineTo(15.033f)
            lineTo(19.04f, 15.038f)
            curveTo(18.541f, 15.11f, 18.279f, 15.048f, 18.279f, 14.827f)
            curveTo(18.279f, 14.711f, 18.331f, 14.073f, 18.418f, 13.072f)
            lineTo(18.427f, 12.962f)
            curveTo(18.46f, 12.592f, 18.494f, 12.201f, 18.529f, 11.815f)
            lineTo(18.562f, 11.443f)
            lineTo(18.572f, 11.34f)
            lineTo(18.575f, 11.303f)
            lineTo(18.579f, 11.263f)
            horizontalLineTo(19.899f)
            close()
            moveTo(19.641f, 14.804f)
            curveTo(19.986f, 15.055f, 20.126f, 15.051f, 20.126f, 14.827f)
            curveTo(20.126f, 14.551f, 20.024f, 13.39f, 19.82f, 11.351f)
            horizontalLineTo(18.659f)
            lineTo(18.649f, 11.451f)
            lineTo(18.616f, 11.823f)
            curveTo(18.581f, 12.209f, 18.547f, 12.599f, 18.514f, 12.97f)
            lineTo(18.505f, 13.08f)
            curveTo(18.418f, 14.073f, 18.367f, 14.715f, 18.367f, 14.827f)
            curveTo(18.367f, 14.962f, 18.567f, 15.013f, 18.99f, 14.957f)
            verticalLineTo(13.172f)
            curveTo(18.99f, 12.983f, 19.018f, 12.759f, 19.063f, 12.642f)
            curveTo(19.138f, 12.449f, 19.263f, 12.503f, 19.361f, 12.782f)
            curveTo(19.492f, 13.151f, 19.585f, 13.824f, 19.641f, 14.804f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF824028)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(20.911f, 10.178f)
            curveTo(20.911f, 10.178f, 20.667f, 11.101f, 20.559f, 11.101f)
            curveTo(20.451f, 11.101f, 19.796f, 10.535f, 19.796f, 10.535f)
            verticalLineTo(11.304f)
            horizontalLineTo(18.576f)
            verticalLineTo(10.963f)
            lineTo(18.42f, 11.304f)
            lineTo(18.206f, 11.199f)
            lineTo(17.837f, 10.741f)
            horizontalLineTo(18.206f)
            curveTo(18.206f, 10.741f, 18.313f, 10.006f, 18.313f, 9.889f)
            curveTo(18.313f, 9.773f, 18.309f, 9.543f, 18.576f, 9.46f)
            curveTo(18.843f, 9.377f, 18.974f, 9.229f, 18.974f, 9.229f)
            curveTo(18.974f, 9.229f, 18.399f, 8.363f, 18.837f, 8.363f)
            curveTo(19.275f, 8.363f, 19.473f, 8.474f, 19.473f, 8.474f)
            curveTo(19.473f, 8.474f, 19.473f, 8.988f, 19.473f, 9.109f)
            curveTo(19.473f, 9.229f, 20.101f, 9.087f, 20.101f, 9.46f)
            curveTo(20.101f, 9.833f, 20.394f, 10.178f, 20.394f, 10.178f)
            lineTo(20.469f, 9.928f)
            lineTo(20.911f, 10.178f)
            close()
        }
        path(
            fill = SolidColor(Color.Black),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(19.066f, 8.576f)
            curveTo(18.824f, 8.576f, 18.629f, 8.475f, 18.629f, 8.35f)
            curveTo(18.629f, 8.225f, 18.824f, 8.124f, 19.066f, 8.124f)
            curveTo(19.307f, 8.124f, 19.503f, 8.225f, 19.503f, 8.35f)
            curveTo(19.503f, 8.475f, 19.307f, 8.576f, 19.066f, 8.576f)
            close()
        }
        path(fill = SolidColor(Color(0xFFBA611F))) {
            moveTo(21.525f, 10.346f)
            lineTo(18.853f, 8.953f)
            curveTo(18.853f, 8.953f, 18.803f, 8.485f, 18.287f, 8.344f)
            curveTo(17.771f, 8.203f, 17.359f, 7.985f, 17.359f, 7.985f)
            lineTo(17.124f, 8.344f)
            curveTo(17.124f, 8.344f, 16.705f, 8.233f, 18.287f, 8.953f)
            curveTo(19.868f, 9.672f, 18.227f, 8.563f, 18.677f, 8.953f)
            lineTo(21.525f, 10.346f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun BelizePreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Belize,
            contentDescription = "Belize Flag"
        )
    }
}
